<app-headnav [user]="userName" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<!--div class="task-box" cdkDrag *ngIf="expanded" [style.right.px]="taskBoxRight">
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;
	border-right: 1px solid white;
    border-top: 1px solid white;
    border-left: 1px solid white;"
	>
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">

		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div>

<div class="task-box" *ngIf="!expanded" style="position:absolute; top: 10px" [style.right.px]="taskBoxRight"> 
	<div class="row" style="background-color: rgb(28 36 51);  border-radius: 3px; padding-top: 0.375rem;
    padding-right: 0.375rem;
    padding-bottom: 0.375rem;
    padding-left: 0.375rem;">
		<span>
			<a style="cursor: pointer; color: white;" (click)="expandcollapse();" title="Expand/Collapse">
				<i *ngIf="!expanded" style="margin-left: 5px;  margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-right" size="lg"></i>
				<i *ngIf="expanded" style="margin-left: 5px; margin-bottom: 2px; vertical-align: middle;" class="fas fa-chevron-down" size="lg"></i>
			</a>
		</span>

		<span *ngIf="!expanded" style="font-size: 16px; margin-left:10px; color: white;">News
				Alert</span>
		<span *ngIf="expanded" style="font-size: 16px; margin-left:32%; color: white;">News
				Alert</span>
	</div>
	<div *ngIf="expanded" class="row">

		<iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

		</iframe>
	</div>
</div-->

<div *ngIf="!userId" class="studio">
  <!--<div class="loading">
    <img src="assets/images/loader.gif" alt="spinner" width="64" height="64" />
  </div>-->
</div>
<div *ngIf="userId" class="studio">
  <section class="content">
    <div class="sidenav flex-container" [style.width]="sideNavWidth">
      <a href="#" title="Dashboard" >
        <!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
        <span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
        </span>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

      </a>
      <!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
      <a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
      </a>
      <a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Templates</span>

      </a>
      <a href="complete" title="Completed Reports" target=_blank>
        <i style="margin-left: 5px" class="far fa-list-alt"></i>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
      </a>
      <!--hr class="m-2" style="background:grey; z-index:9999999;"-->
      <a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank class="active"><i class="icon-property" style="font-size:28px"></i>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

      </a>

      <!--hr class="m-2" style="background:grey; z-index:9999999;"-->
      <a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank>
        <span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

      </a>
      <!--hr class="m-2" style="background:grey; z-index:9999999;"-->
      <a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank>
        <i class="icon-eris" style="font-size: 32px;"></i>
        <span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

      </a>

      <a (click)="toggleSideBar()">

        <i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
        <i *ngIf="toggleSideBarVar" class="pi pi-chevron-left" style="font-size: 24px;"></i>

      </a>






    </div>
    <div class="tableView">
      <ul class="nav nav-tabs  nav-justified">
        <li class="nav-item">
          <a class="nav-link active" data-toggle="tab" href="#Reports">Company Information</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" data-toggle="tab" href="#Settings">Report Settings</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="getAllReportUsers(); getCompanyRoles();" data-toggle="tab" href="#Portfolio">Users</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="getClientsByCompany()" data-toggle="tab" href="#menu2">Clients</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="getCompanyFiles('FILE')" data-toggle="tab" href="#FileCenter">Company File
            Center</a>
        </li>
      </ul>

      <div #tableview class="tab-content">
        <div id="Reports" style="color:white; background:rgb(9 17 33)" class="tab-pane active"><br>
          <div style="text-align:center;font-size: 20px; font-weight:600" class="offset-md-4 col-md-4">{{userInfo.COMPANY_NAME}}</div>
            <div *ngIf="userInfo.REGISTERED_RW == 'N'" style="text-align:center; font-size: 14px;" class="offset-md-4 col-md-4 erisGreen1 text-center">
              Your company is not currently registered with Scriva by ERIS. If you would like to create reports, templates, and libraries, please reach out to
              <span> <a class="erisGreen1" style="text-decoration: underline;" href="mailto:scriva_support@erisinfo.com"> scriva_support@erisinfo.com.</a> </span>
              <br>
              Our friendly support team will be happy to assist you with an agreement!
            </div>
          <hr style="color: white; width: 100%; background-color: white;">
          <div class="row" style="background:rgb(9 17 33)">


            <div class="col-md-7" style="height: 100%;">
              <div class="p-4">
                <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link border active" id="officeLocations-tab" data-toggle="tab" href="#officeLocations"
                        role="tab" aria-controls="officeLocations" aria-selected="true">
                      Location / Admin Management
                    </a>
                  </li>
                  <li class="nav-item" (click)="checkManageGroupsPermissionModal($event)">
                    <a class="nav-link border" id="groups-tab" data-toggle="tab" href="#groups"
                        role="tab" aria-controls="groups" aria-selected="false"
                        [class.disabled]="!companyGroupIndicator">
                      Group Management
                    </a>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="officeLocations" role="tabpanel" aria-labelledby="officeLocations-tab">
                    <p-table #asdt styleClass="p-datatable-sm" [value]="companyInfo?.RW_LOCATIONS" [columns]="locationCols" [scrollable]="true" scrollHeight="400px">
                      <ng-template pTemplate="caption">
                        <label style="font-size: 16px;">
                          Office Locations </label>
                        <!-- <a *ngIf="userInfo.SUPER_ADMIN_USER=='Y'" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background-color: #C2D63F; color:black; font-weight:600" data-toggle="modal" data-target="#companyModal" (click)="newCompany=true; clearCompanyLocation()"> -->
                        <a *ngIf="manageCompanyPermission" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background-color: #C2D63F; color:black; font-weight:600" data-toggle="modal" data-target="#companyModal" (click)="newCompany=true; clearCompanyLocation()">
                          Add New Office Location</a>
                        <!--input type="text" pInputText size="20" placeholder="Search" (input)="asdt.filterGlobal($event.target.value, 'contains')" style="width:auto; float:right"-->
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr style="font-size:12px">
                          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns" style="height: 100px;">
                        <tr style="font-size:12px; overflow: scroll;">
                          <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="overflow: ellipsis;" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                            <span class="line-clamp1" *ngIf="col.field!='HF_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'&&col.field!='FULL_ADDRESS'" style="float:left; overflow: ellipsis;">{{user[col.field]}} </span>
                            <span class="line-clamp1" *ngIf="col.field=='HEAD_OFFICE'">
                              <a title="Change status" style="cursor:pointer; float:right; color: rgb(201 218 251);" *ngIf="user.HEAD_OFFICE=='Y'" (click)="changeHead(user); popupControl=false">
                                <i class="fas fa-toggle-on"></i>
                              </a>
                              <a title="Change status" style="cursor:pointer; color: rgb(201 218 251); float:right" *ngIf="user.HEAD_OFFICE!='Y'" (click)="changeHead(user); popupControl=false">
                                <i class="fas fa-toggle-off"></i>
                              </a>
                            </span>
                            <span class="line-clamp1" *ngIf="col.field=='FULL_ADDRESS' && user.FULL_ADDRESS">
                              <a [title]="user.FULL_ADDRESS" class="line-clamp1" style="cursor: pointer; margin-right:19px; max-width:calc(100% - 20px); overflow: ellipsis;"><i (click)="op.toggle($event); getCords1(user)" class="fas fa-map-marker-alt" style="float:right; margin:3px; color:rgb(201 218 251)"></i>
                                {{user[col.field]}} </a>
      
                              <div>
                              </div>
                              <p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [style]="{width: '550px', height: '550px'}" (onHide)="onHide()">
                                <span style="color:rgb(195,212,47)">
                                  {{user.FULL_ADDRESS}}
                                </span>
                                <span *ngIf="!noLocation" style="color: red;">
                                  (Address not found)
                                </span><br>
                                <!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="user.lat" [longitude]="user.long" [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false">
                                  <agm-marker *ngIf="noLocation" [latitude]="user.lat" [longitude]="user.long">
      
                                    <agm-info-window>
                                      <strong>{{user.FULL_ADDRESS}}</strong>
                                    </agm-info-window>
                                  </agm-marker>
                                </agm-map>-->
                                <div id="googleMap2" class="googleMap2"></div>
                              </p-overlayPanel>
                            </span>
      
                            <span class="line-clamp1" *ngIf="col.field=='EDIT'">
                              <!-- <a *ngIf="userInfo.SUPER_ADMIN_USER=='Y'" style="cursor: pointer; text-decoration: underline; margin-left:10px; color: rgb(201 218 251);" data-toggle="modal" -->
                              <a *ngIf="manageCompanyPermission" style="cursor: pointer; text-decoration: underline; margin-left:10px; color: rgb(201 218 251);" data-toggle="modal"
                                (click)="fillCompany(user); newCompany=false; locationId=user.LOCATION_ID;" data-target="#companyModal">
                                <i class="fas fa-edit"></i></a>
                            </span>
                            <span class="line-clamp1" *ngIf="col.field=='STATUS'">
                              <a title="Change status" style="cursor:pointer; float:right; color: rgb(201 218 251);" *ngIf="user.STATUS=='Active'" (click)="deleteCompanyLocation(user)">
                                <i class="fas fa-toggle-on"></i>
                              </a>
                              <a title="Change status" style="cursor:pointer; color: rgb(201 218 251); float:right" *ngIf="user.STATUS!='Active'" (click)="deleteCompanyLocation(user)">
                                <i class="fas fa-toggle-off"></i>
                              </a>
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
  
                    <p-table #asdt styleClass="p-datatable-sm" [value]="companyInfo?.RW_SYSTEM_MANAGERS" [columns]="contactCols" [scrollable]="true" scrollHeight="200px">
                      <ng-template pTemplate="caption">
                        <hr>
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                          <h4 style="font-size: 16px;">
                            Main Contact/Administrator
                          </h4>
                          <span>
                            
                          </span>
                        </div>
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
      
                        <tr style="font-size:12px">
                          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
                        <tr style="font-size:12px">
                          <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
      
                            <span class="line-clamp1" *ngIf="col.field!='HF_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                            
                            <span class="line-clamp1" *ngIf="col.field=='SUPER_ADMIN_USER'">
                              <a title="Change status" style="cursor:pointer; float:right; color: rgb(201 218 251);" *ngIf="user.SUPER_ADMIN_USER=='Y'" (click)="changeSuperAdmin(user); popupControl=false">
                                <i class="fas fa-toggle-on"></i>
                              </a>
                              <a title="Change status" style="cursor:pointer; color: rgb(201 218 251); float:right" *ngIf="user.SUPER_ADMIN_USER!='Y'" (click)="changeSuperAdmin(user); popupControl=false">
                                <i class="fas fa-toggle-off"></i>
                              </a>
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div class="tab-pane fade w-100" id="groups" role="tabpanel" aria-labelledby="groups-tab">
                    <p-table #asdt *ngIf="manageGroupsPermission" styleClass="p-datatable-sm" [value]="companyGroups" [columns]="groupCols" [scrollable]="true" scrollHeight="max(calc(100vh - 450px), 300px)">
                      <ng-template pTemplate="caption">
                        <label style="font-size: 16px;"> Groups </label>
                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background-color: #C2D63F; color:black; font-weight:600"
                            data-toggle="modal" data-target="#groupModal" (click)="getCompanyGroupUserList(); newGroup=true; clearGroup()">
                          Add New Group</a>
                      </ng-template>
                      <ng-template pTemplate="header" let-columns>
                        <tr style="font-size:12px">
                          <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-group let-i="rowIndex" let-columns="columns" style="height: 100px;">
                        <tr style="font-size:12px; overflow: scroll;">
                          <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="overflow: ellipsis;" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                            <span class="line-clamp1" *ngIf="col.field=='GROUP_NAME'" style="float:left; overflow: ellipsis;">
                              {{ group[col.field] }}
                            </span>
      
                            <!-- <span class="line-clamp1" *ngIf="col.field=='USERS'" style="float:left; overflow: ellipsis">
                              {{ extractFullNames(group) }}
                            </span> -->
                            
                            <span class="line-clamp1" *ngIf="col.field=='STATUS'">
                              {{group[col.field]}}
                              <a title="Change status" style="cursor:pointer; float:right; color: rgb(201 218 251);"
                                  *ngIf="group.STATUS==='Active'" (click)="removeCompanyGroup(group)">
                                <i class="fas fa-toggle-on"></i>
                              </a>
                              <a title="Change status" style="cursor:pointer; color: rgb(201 218 251); float:right;"
                                  *ngIf="group.STATUS!=='Active'" (click)="activateCompanyGroup(group)">
                                <i class="fas fa-toggle-off"></i>
                              </a>
                            </span>
                      
                            <span class="line-clamp1" *ngIf="col.field=='EDIT'">
                              <a style="cursor: pointer; text-decoration: underline; margin-left:10px; color: rgb(201 218 251);"
                                  data-toggle="modal" (click)="getCompanyGroupUserList(); fillGroup(group); inputGroupID=group.GROUP_ID; newGroup=false;" data-target="#groupModal">
                                <i class="fas fa-edit"></i>
                              </a>
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
            </div>
            <div style="color:black" class="col-md-5">
              <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 76vh;">
                  <!-- <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Company Settings</h4>
                  </div> -->
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <form [formGroup]="form">
                      <div class="md-form mb-3">
                        <div class="container">
                          <div>
                            <!-- <label style="margin-left:-15px; font-size: 12px;" class="col-md-11 " data-error="wrong" data-success="right" for="defaultForm-email">
                              Internal Users Can Access Projects and Reports Automatically?</label>
                            <span class="col-md-1 checkbox-inline">
                              <input type="checkbox" class="form-check-input erisGreen1" [checked]="profileQuestions.GRANT_ACCESS=='Y'"
                                  (change)="updateProfile({'GRANT_ACCESS':$event.target.checked?'Y':'N'})" [disabled]="!manageCompanyPermission" />
                            </span>
                            <br />
                            <br /> -->
                           
                              <div style="border-bottom: 0px" class="modal-header text-center">
                                <h4 class="modal-title w-100" style="font-size: 16px;">
                                  PCA Cost Table Format
                                </h4>
                              </div>
                              <p-table *ngIf="!settingsTile" #asdt styleClass="p-datatable-sm" [columns]="settingsCols1">
                                <ng-template pTemplate="caption" style="height: 50%;">
                                  <input disabled style=" font-size: 12px; background-color: gray;" type="radio" name="selection" [checked]="profileQuestions.PCA_TABLE_STYLE=='A'" value='A'
                                        (change)="updateProfile({'PCA_TABLE_STYLE':'A'})"> Format A  <!-- [disabled]="!manageCompanyPermission&&profileQuestions.PCA_TABLE_STYLE!='A'"-->
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                  <tr style="font-size:9px">
                                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size: 9px">
                                      {{col.header}}
                                  </tr>
                                </ng-template>
                              </p-table>
                            
                            <br>
                            
                              <p-table *ngIf="!settingsTile" #asdt styleClass="p-datatable-sm" [columns]="settingsCols2">
                                <ng-template pTemplate="caption" style="height: 50%;">
                                  <input style=" font-size: 12px; background-color: gray;" type="radio" name="selection" [checked]="profileQuestions.PCA_TABLE_STYLE=='B'" value='B'
                                        (change)="updateProfile({'PCA_TABLE_STYLE':'B'});" [disabled]="!manageCompanyPermission&&profileQuestions.PCA_TABLE_STYLE!='B'"> Format B
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                  <tr style="font-size:9px">
                                    <th *ngFor="let cols of columns" [ngStyle]="{'width': cols.width}" style="padding:1px; font-size:9px">
                                      {{cols.header}}
                                  </tr>
                                </ng-template>
                              </p-table>
                            
                          </div>
                            <hr>
                            
                            <h4 style="font-size: 16px;text-align: center;">
                              Fannie Mae Settings
                            </h4>
                            <div style="font-size: 12px;">
                               <button style="font-size: 11px; padding: 4px 0; width: 100%; background-color: #ccc;" (click)="checkCloserSettingsPermission('fme')">Fannie Mae Data Input Setup</button>
                            </div>
                          <hr>                            
                            <h4 style="font-size: 16px;text-align: center;">
                              Closer Settings
                            </h4>
                            <div style="font-size: 12px;">
                              <button style="font-size: 11px; padding: 4px 0; width: 100%; background-color: #ccc;" (click)="checkCloserSettingsPermission('closer')">Closer Data Input Setup</button>
                            </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="FileCenter" style="color:rgb(110, 97, 97);" class="tab-pane fade"><br>
          <p-table #pt2 styleClass="p-datatable-sm" [value]="companyFiles" [columns]="fileCols" [scrollable]="true" scrollHeight="calc(100vh - 200px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  {{numFiles}}
                  Files
                  <i *ngIf="filesLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

                  <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:rgb(195,212,47); color:black" data-toggle="modal" data-target="#newFile"
                    (click)="editFile=false;clearFileForm();uploadNewFilePermission = false;checkUploadNewFilePermission();">
                    <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                    Add New File
                  </a>
                  <i class="fas fa-info-circle fa-lg" style="color: white; text-align: center; margin-left: 5px; vertical-align: -5px;" (mouseover)="op.toggle($event)"
                                            (mouseleave)="op.toggle($event)"></i>
                                            <p-overlayPanel #op [appendTo]="'body'">
                                              <ng-template pTemplate>
                                                <ng-container>
                                                  <p style="color: white; margin-top: 10px" >
                                                  * Only files under 100MB and with filenames of less than 100 characters will upload. 
                                                  </p> 

                                                </ng-container>
                                              </ng-template>
                                            </p-overlayPanel>
                  <span style="padding: 5px; color: white; font-size:12px">
                    Group By :
                    <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white; width: 140px" [ngClass]="{'active':groupKey=='IMAGE'}" (click)="getCompanyFiles('IMAGE')">Image</button>
                    <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white; width: 140px" [ngClass]="{'active':groupKey=='LOGO'}" (click)="getCompanyFiles('LOGO')">Logo</button>
                    <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white; width: 140px" [ngClass]="{'active':groupKey=='FILE'}" (click)="getCompanyFiles('FILE')">File</button>
                    <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white; width: 140px" [ngClass]="{'active':groupKey=='BKIMAGE'}" (click)="getCompanyFiles('BKIMAGE')">Background Image</button>
                    <!-- <button [ngClass]="{'active':groupKey=='USER_RESUME'}" (click)="getCompanyFiles('USER_RESUME')">User
                      Resume</button>
                    <button [ngClass]="{'active':groupKey=='USER_SIGNATURE'}"
                      (click)="getCompanyFiles('USER_SIGNATURE')">User Signature</button> -->
                    <!-- <button [ngClass]="{'active':groupkey=='REPORT_DUE_DATE'}"
                      (click)="getAllReportByGroup('REPORT_DUE_DATE')">Report Due Date</button>
                    <button [ngClass]="{'active':groupkey=='PROJECT_NUMBER'}"
                      (click)="getAllReportByGroup('PROJECT_NUMBER')">Project</button>
                    <button [ngClass]="{'active':groupkey=='RECENT_DATE'}"
                      (click)="getAllReportByGroup('RECENT_DATE')">My Recent Work</button> -->
                    <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                    
                  </span>
                  
                    <!--
                      <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-4" style="background:#58a400; color:white"
                      (click)="toggleUser()">
                      Toggle View
                    </a>
                    -->
                  </span>
                  <div>
                    <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white" (input)="pt2.filterGlobal($event.target.value, 'contains')">
                    </div>
                    
              </div>
            
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns| slice:0:6; let i=index" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon *ngIf="i!=5" [field]="col.field"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px;">
                <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                  <span class="line-clamp1" *ngIf="col.field!='FILE_NAME' &&col.field!='FILE_DESCRIPTION' &&col.field!='EDIT' && col.field!='STATUS'">{{user[col.field]}}
                  </span>
                  <span *ngIf="col.field=='FILE_DESCRIPTION'">
                    <div [title]="user[col.field]" style="overflow: hidden; max-width:calc(100% - 30px); display:inline-block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      {{user[col.field]}}
                    </div>
                    <a style="cursor:pointer; float:right" (click)="editFile=true; editFileID=user.FILE_ID; fileDesc=user.FILE_DESCRIPTION; op1.toggle($event)">
                      <i class="fas fa-edit erisIconColor m-1"></i>
                    </a>
                  </span>
                  <p-overlayPanel #op1 [appendTo]="'body'">
                    <textarea maxlength="100" style="height:200px; width:300px" class="rptInfo" type="text" [(ngModel)]="fileDesc"></textarea>
                    <br>
                    <button (click)="updateCompanyFile(); op1.hide()" class="btn m-0 uploadBtn">Submit</button>
                    <span style='float:right; font-size:10px'>
                      {{fileDesc.length}} /100
                    </span>
                  </p-overlayPanel>
                  <span class="line-clamp1" *ngIf="col.field=='FILE_NAME'">
                    <a (mouseenter)="op1.toggle($event)" (mouseleave)="op1.toggle($event)" target="_blank" [href]="user['FILE_URL']" style="color:rgb(195,212,47);cursor:pointer"> {{user[col.field]}}</a>
                    <p-overlayPanel #op1 [appendTo]="'body'">
                      <img style="max-width:500px; max-height:500px; height: auto; 
                      width: auto; " [src]="user['FILE_URL']">
                    </p-overlayPanel>
					<input *ngIf="groupKey=='LOGO'" type="checkbox" style="float:right" title="Set Default" [checked]="user.COMPANY_DEFAULT=='Y'" (change)="setDefault(user.FILE_ID)">
				
                  </span>
                  <span *ngIf="col.field=='EDIT'">
                    <a data-toggle="modal" data-target="#deleteModal" style="cursor:pointer" (click)="toDeleteFile=user"><i class="fas fa-trash erisIconColor m-1"></i></a>
				  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div id="Settings" class="tab-pane fade">
          <div class="row">
            <div style="color:black; height:90%" class="col-md-3">
              <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 76vh;overflow: auto;">
                  <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Appendix Settings</h4>
                  </div>
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <div class="md-form mb-3">
                      <div class="container">
                        <div class="row">
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">
                            Do you require a Divider page for each appendix?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="profileQuestions.APPENDIX_TITLEPAGE_IND==='Y'" [disabled]="!manageReportSettingsPermission"
                            (change)="profileQuestions.APPENDIX_TITLEPAGE_IND=$event.target.checked?'Y':'N'; updateProfile({'APPENDIX_TITLEPAGE_IND':profileQuestions.APPENDIX_TITLEPAGE_IND})">
                          </span>
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">Do you list file names for an appendix in the Table of Contents and on the Divider page?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="profileQuestions.APPENDIX_TITLEPAGE_FILE_IND==='Y'" [disabled]="!manageReportSettingsPermission"
                            (change)="profileQuestions.APPENDIX_TITLEPAGE_FILE_IND=$event.target.checked?'Y':'N'; updateProfile({'APPENDIX_TITLEPAGE_FILE_IND':profileQuestions.APPENDIX_TITLEPAGE_FILE_IND})">
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="border-bottom: 0px" class="modal-header text-center">
                      <h4 class="modal-title w-100" style="font-size: 16px;">Table of Content Settings</h4>
                    </div>
                    <div class="md-form mb-3">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-12">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Page Number Format:</label>
                            <div style="font-size: 12px;">
                              <input style=" font-size: 12px; background-color: gray;" type="radio" [checked]="profileQuestions.TOC_PAGENUMBER_FORMAT=='int'" value="int"
                                (change)="updateProfile({'TOC_PAGENUMBER_FORMAT':'int'})" [disabled]="!manageReportSettingsPermission&&profileQuestions.TOC_PAGENUMBER_FORMAT!='int'">
                                Number
                              <input style=" font-size: 12px; background-color: gray;" type="radio" [checked]="profileQuestions.TOC_PAGENUMBER_FORMAT=='roman'" value="roman"
                                (change)="updateProfile({'TOC_PAGENUMBER_FORMAT':'roman'})" [disabled]="!manageReportSettingsPermission&&profileQuestions.TOC_PAGENUMBER_FORMAT!='roman'">
                                Roman
                            </div>
                          </div>
                          <div class="col-md-12 p-0" >
                            <label style="font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Style Template:</label>
                            
                            <ul class="widget-item-list">
                              <li class="item" *ngFor="let tocstyle of tocstyles; let i=index">
                                <div class="img-wrapper">
                                  <a href="javascript:void(0)" (click)="open(i)"><img [src]="tocstyle.TOC_IMAGE_URL" class="img img-fluid" /></a>
                                </div>
                                <div *ngIf="tocstyle.TOC_FILENAME.length>0" class="title">
                                  <input type="radio" [checked]="profileQuestions.TOC_STYLE_ID==tocstyle.TOC_STYLE_ID" value="{{tocstyle.TOC_STYLE_ID}}"
                                    (change)="updateProfile({'TOC_STYLE_ID':tocstyle.TOC_STYLE_ID})"
                                    [disabled]="!manageReportSettingsPermission&&profileQuestions.TOC_STYLE_ID!=tocstyle.TOC_STYLE_ID">
                                    {{tocstyle.TOC_FILENAME}}
                                </div>
                              </li>
                            </ul>
                          
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="color:black; height:90%" class="col-md-3">
              <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 76vh;overflow: auto;">
                  <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Report Settings</h4>
                  </div>
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <div class="md-form mb-3">
                      <div class="container">
                        <div>
                          <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Current Company Profile:</label>
                          <button style="padding:0 4px; margin: 0 4px;" class="btn btn-default btn-outline-light float-sm-right btn-sm"
                            (click)="createNewProfile()">
                             Create New Profile</button>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions['COMP_PROFILE_ID']" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission" (change)="getCompanyProfile($event)">
                              <option *ngFor="let profile of profiles" [value]="profile.COMP_PROFILE_ID" [selected]="companyInfo?.RW_PROFILE_SETTINGS[0].COMP_PROFILE_ID==profile.COMP_PROFILE_ID">{{profile.REPORT_STYLE_NAME}}
                              </option>
                            </select>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 1 Font:</label>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions.HEADING1_FONT_STYLE" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission">
                              <option *ngFor="let f of allFont" [value]="f">{{f}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 1 Font Size:</label>
                            <input type="number" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING1_FONT_SIZE" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 2 Font:</label>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions.HEADING2_FONT_STYLE" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission">
                              <option *ngFor="let f of allFont" [value]="f">{{f}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 2 Font Size:</label>
                            <input type="number" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING2_FONT_SIZE" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 3 Font:</label>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions.HEADING3_FONT_STYLE" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission">
                              <option *ngFor="let f of allFont" [value]="f">{{f}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 3 Font Size:</label>
                            <input type="number" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING3_FONT_SIZE" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Text Font:</label>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions.REPORT_FONT_STYLE" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission">
                              <option *ngFor="let f of allFont" [value]="f">{{f}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Text Font Size:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.REPORT_BODY_FONT_SIZE" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Table Head BG Color:</label>
                            <input type="text" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(colorPicker)]="profileQuestions.TABLE_HEADER_COLOUR" [(ngModel)]="profileQuestions.TABLE_HEADER_COLOUR" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Table Head Font Color:</label>
                            <input type="text" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(colorPicker)]="profileQuestions.TABLE_HEADER_FONT_COLOUR" [(ngModel)]="profileQuestions.TABLE_HEADER_FONT_COLOUR" [disabled]="!manageReportSettingsPermission">
                          </div>
                          
                        </div>
                        <div class="row">
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">Do you want your heading 1 indented?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="profileQuestions.HEADING1_INDENT=='Y'" (change)="profileQuestions.HEADING1_INDENT=$event.target.checked?'Y':'N'"
                              [disabled]="!manageReportSettingsPermission&&profileQuestions.HEADING1_INDENT!='Y'">
                          </span>
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">Do you want your heading 2 indented?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="profileQuestions.HEADING2_INDENT=='Y'" (change)="profileQuestions.HEADING2_INDENT=$event.target.checked?'Y':'N'"
                              [disabled]="!manageReportSettingsPermission&&profileQuestions.HEADING2_INDENT!='Y'">
                          </span>
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">Do you want your heading 3 indented?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="profileQuestions.HEADING3_INDENT=='Y'" (change)="profileQuestions.HEADING3_INDENT=$event.target.checked?'Y':'N'"
                              [disabled]="!manageReportSettingsPermission&&profileQuestions.HEADING3_INDENT!='Y'">
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="border-top: 0px" class="modal-footer d-flex justify-content-center">
                    <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
                    (click)="updateReportSettings()" [disabled]="profileQuestions.REPORT_STYLE_CUSTOMIZED=='Y'||!manageReportSettingsPermission">
                      Update Settings</button>
                    <button (click)="updateBodyHeadCss(); htmlShow=true" style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark">Style Source</button>
                  </div>
                </div>
              </div>
            </div>
			<div style="color:black; height:90%" class="col-md-3">
              <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 76vh;overflow: auto;">
                  <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Additional Report Info</h4>
                  </div>
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <div class="md-form mb-3">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 1 Prefix:</label>
                            <input type="text" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING1_DESIGN" [disabled]="!manageReportSettingsPermission">
                          </div>
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Heading 1 Spacing:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING1_SPACING" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 2 Prefix:</label>
                            <input type="text" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING2_DESIGN" [disabled]="!manageReportSettingsPermission">
                          </div>
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Heading 2 Spacing:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING2_SPACING" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Heading 3 Prefix:</label>
                            <input type="text" class="form-control validate rptInfo  mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING3_DESIGN" [disabled]="!manageReportSettingsPermission">
                          </div> 
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Heading 3 Spacing:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.HEADING3_SPACING" [disabled]="!manageReportSettingsPermission">
                          </div>
						<hr>
						<div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Report Margin Top:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.REPORT_MARGIN_TOP" [disabled]="!manageReportSettingsPermission">
                          </div>
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Report Margin Bottom:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.REPORT_MARGIN_BOTTOM" [disabled]="!manageReportSettingsPermission">
                          </div>
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Report Margin Left:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.REPORT_MARGIN_LEFT" [disabled]="!manageReportSettingsPermission">
                          </div>
						  <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Report Margin Right:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.REPORT_MARGIN_RIGHT" [disabled]="!manageReportSettingsPermission">
                          </div>
                          <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">Date Format:</label>
                            <select class="form-control validate rptInfo mb-3" [(ngModel)]="profileQuestions.DATE_FORMAT_ID" style="margin-left:-15px; background:#222;color:white"
                              [disabled]="!manageReportSettingsPermission">
                              <option *ngFor="let item of allFormat" [value]="item.DATE_FORMAT_ID">{{item.DATE_FORMAT}}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="row">
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-4" data-error="wrong" data-success="right" for="defaultForm-email">Header Line</label>
                          <span class="col-md-8">
                            <select class="validate form-select-input" style="font-size:11px" [(ngModel)]="profileQuestions.HEADER_LINE"  [disabled]="!manageReportSettingsPermission">
								<option value="Y">Y</option>
								<option value="N">N</option>
							</select>
						 </span>
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-4" data-error="wrong" data-success="right" for="defaultForm-email">Footer Line</label>
                          <span class="col-md-8">
                            <select class="validate form-select-input" style="font-size:11px" [(ngModel)]="profileQuestions.FOOTER_LINE"  [disabled]="!manageReportSettingsPermission">
								<option value="Y">Y</option>
								<option value="N">N</option>
							</select>
						 </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="border-top: 0px" class="modal-footer d-flex justify-content-center">
                    <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
                    (click)="updateAdditional()" [disabled]="!manageReportSettingsPermission"><!--profileQuestions.REPORT_STYLE_CUSTOMIZED=='Y'||-->
                      Update Settings</button>                  
                  </div>
                </div>
              </div>
            </div>
            <div style="color:black; height:90%" class="col-md-3">
              <div class="modal-dialog" role="document">
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 38vh;overflow: auto;">
                  <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Table of Content Settings for Report</h4>
                  </div>
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <div class="md-form mb-0">
                      <div class="container">
                        <div class="row">                          
						              <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">TOC Margin Top:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.TOC_MARGIN_TOP" [disabled]="!manageReportSettingsPermission">
                          </div>
						              <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">TOC Margin Bottom:</label>
                            <input type="number" class="form-control validate  rptInfo mb-3" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.TOC_MARGIN_BOTTOM" [disabled]="!manageReportSettingsPermission">
                          </div>
						              <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">TOC Margin Left:</label>
                            <input type="number" class="form-control validate  rptInfo mb-1" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.TOC_MARGIN_LEFT" [disabled]="!manageReportSettingsPermission">
                          </div>
						              <div class="col-md-6">
                            <label style="margin-left:-15px; font-size: 12px" data-error="wrong" data-success="right" for="defaultForm-email">TOC Margin Right:</label>
                            <input type="number" class="form-control validate  rptInfo mb-1" style="margin-left:-15px; background:#222;color:white"
                              [(ngModel)]="profileQuestions.TOC_MARGIN_RIGHT" [disabled]="!manageReportSettingsPermission">
                          </div>
                          
                        </div>
                        <div class="row mt-2">
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-9" data-error="wrong" data-success="right" for="defaultForm-email"> TOC header and footer are same as report</label>
                          <span class="col-md-3">
                            <select class="validate form-select-input  col-md-12 p-0" style="font-size:11px" [(ngModel)]="profileQuestions.TOC_HF_REPORT_IND" (change)="removeTOCHF($event)" [disabled]="!manageReportSettingsPermission">
                              <option value="Y">Y</option>
                              <option value="N">N</option>
                            </select>
                          </span>
                        </div>  
                        <div class="row">         
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-3" data-error="wrong" data-success="right" for="defaultForm-email">Header</label>
                          <span class="col-md-9">
                            <select class="validate form-select-input col-md-12" style="font-size:11px" [(ngModel)]="profileQuestions.TOC_HEADER_ID"  [disabled]="!manageReportSettingsPermission||profileQuestions.TOC_HF_REPORT_IND=='Y'">
                              <option *ngFor="let header of headers" [value]="header.HEADERFOOTER_ID">{{header.HF_TITLE}}</option>
                            </select>
                          </span>              
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-3" data-error="wrong" data-success="right" for="defaultForm-email">Footer</label>
                          <span class="col-md-9">
                            <select class="validate form-select-input col-md-12" style="font-size:11px" [(ngModel)]="profileQuestions.TOC_FOOTER_ID"  [disabled]="!manageReportSettingsPermission||profileQuestions.TOC_HF_REPORT_IND=='Y'">
                              <option *ngFor="let footer of footers" [value]="footer.HEADERFOOTER_ID">{{footer.HF_TITLE}}</option>                              
                            </select>
                          </span>
                        </div>          
                      </div>
                    </div>
                  </div>
                  <div style="border-top: 0px" class="modal-footer d-flex justify-content-center">
                    <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
                    (click)="updateTOC()" [disabled]="!manageReportSettingsPermission"><!--profileQuestions.REPORT_STYLE_CUSTOMIZED=='Y'||-->
                      Update Settings</button>                  
                  </div>
                </div>
                <div class="modal-content" style="background:rgb(28 36 51); color:white; height: 37vh;margin-top: 1vh;overflow: auto;">
                  <div style="border-bottom: 0px" class="modal-header text-center">
                    <h4 class="modal-title w-100" style="font-size: 16px;">Signature Settings</h4>
                  </div>
                  <div style="border-bottom: 0px" class="modal-body mx-3">
                    <div class="md-form mb-0">
                      <div *ngIf="selectedSign" class="container">
                        <div>
                          <label style="margin-left:-15px; font-size: 12px;" data-error="wrong" data-success="right" for="defaultForm-email">Signature Profile:</label>
                          <button style="padding:0 4px; margin-right:16px;" class="btn btn-default btn-outline-light float-sm-right btn-sm"
                            (click)="createNewSignatureStyle()" [disabled]="!manageReportSettingsPermission">
                             Create New Signature Profile</button>
                             <div style="display:flex; width:100%; border:1px solid #666; border-radius:4px; overflow:hidden;">
                              <select class="form-control validate rptInfo mb-1"
                                      [(ngModel)]="selectedSign['SIGNATURE_STYLE_ID']"
                                      [disabled]="!manageReportSettingsPermission"
                                      style="flex:1; background:#222; color:white; border:none; border-radius:0;">
                                <option *ngFor="let signStyle of signStyles"
                                        [value]="signStyle.SIGNATURE_STYLE_ID">
                                  {{signStyle.SIGNATURE_STYLE_NAME}}
                                </option>
                              </select>
                            
                              <button class="btn btn-default btn-outline-light btn-sm"
                                      (click)="openSignatureStyleSettings()"
                                      title="Signature Style Settings"
                                      [disabled]="!manageReportSettingsPermission"
                                      style="border:none; border-left:1px solid #666; border-radius:0;">
                                <i class="fas fa-bars"></i>
                              </button>
                            </div>                      
                        </div> 
                        <div class="row mt-2">         
                          <label style="margin-left:-15px; font-size: 12px;" class="col-md-5" data-error="wrong" data-success="right" for="defaultForm-email">Signature Role:</label>
                            <ul class="col-md-7" style="font-size: 12px">
                              <li *ngFor="let role of signatureroles;">{{role.SIGNATURE_LABEL_NAME}}<app-edit-input [text]="role.SIGNATURE_LABEL_NAME" (edited)="updateSignatureRole($event, role)" [disabled]="!manageReportSettingsPermission"></app-edit-input>
                              </li>
                              
                              <!--<p-overlayPanel #op4 [appendTo]="'body'" [style]="{'width':'300px'}">
                                <input #signatureRole type="text" [value]="role" style="width:80%" />
                                <button type="button" class="btn btn-primary" (click)="updateSignatureRole(role); op4.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;">Update</button>
                              </p-overlayPanel>-->
                            </ul>                          
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-6" data-error="wrong" data-success="right" for="defaultForm-email">Signature Alignment:</label>
                          <span class="col-md-6 mb-2">
                            <select *ngIf="companyInfo" class="validate form-select-input col-md-12" style="font-size:11px" (change)="setSignAlign($event)" [disabled]="!manageReportSettingsPermission">
                              <ng-container *ngFor="let item of alignments">
                                <option [value]="item.SIGNATURE_ALIGNMENT" [selected]="companyInfo['RW_PROFILE_SETTINGS'][0]['COMPANY_SIGNATURE_ALIGNMENT']['SIGNATURE_ALIGNMENT_CODE']==item.SIGNATURE_ALIGNMENT">{{item.SIGNATURE_ALIGNMENT_DISPLAY}}</option>
                              </ng-container>
                            </select>
                          </span>
                          <!--<label style="margin-left:-15px; font-size: 12px" class="col-md-10" data-error="wrong" data-success="right" for="defaultForm-email">Allow Sign On Behalf of Others</label>
                          <span class="col-md-2 float-sm-right">
                            <input [checked]="companyInfo['RW_PROFILE_SETTINGS'][0]['SIGN_ONBEHALF_OTHERS']=='Y'" (change)="setOnBehalf($event)" type="checkbox">                            
                          </span>-->
                          <label style="margin-left:-15px; font-size: 12px" class="col-md-11" data-error="wrong" data-success="right" for="defaultForm-email">Allow Sign for Others?</label>
                          <span class="col-md-1 checkbox-inline">
                            <input type="checkbox" class="form-check-input" [checked]="companyInfo['RW_PROFILE_SETTINGS'][0]['SIGN_ONBEHALF_OTHERS']=='Y'" (change)="setOnBehalf($event)" [disabled]="!manageReportSettingsPermission">
                          </span>
                        </div>          
                      </div>
                    </div>
                  </div>
                  <div style="border-top: 0px" class="modal-footer d-flex justify-content-center">
                    <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
                    (click)="toEditSignature()" [disabled]="!manageReportSettingsPermission"><!--profileQuestions.REPORT_STYLE_CUSTOMIZED=='Y'||-->
                      Signature Source</button>                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="Portfolio" class="tab-pane fade">
          <div style="background-color:#333;color:white;">
            <p-dataView *ngIf="userview" #dv [value]="usersList" [paginator]="true" [rows]="12" layout="grid" filterBy="FULL_NAME,USER_EMAIL,FIRST_NAME,JOB_TITLE,EXTERNAL_USER,ALTERNATIVE_EMAIL,PHONE_NUMBER,STATUS">
              <ng-template pTemplate="header">
                <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                  <span>
                    Users

                    <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" data-toggle="modal" data-target="#reportsModal2"
                        (click)="newUser=true; resetUserForm();checkManageUsersPermission(null);">
                      <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                      Add New User
                    </a>
                    <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" data-toggle="modal" data-target="#import"
                        (click)="checkUploadBatchUsersPermission()">
                      Add Batch Users
                    </a>
                    <span style="padding: 5px; color: white; font-size:12px">
                      Filter By :
                      <button [ngClass]="{'active':groupkey=='All'}" (click)="dv.filter('','contains'); groupkey='All'">All</button>
                      <button [ngClass]="{'active':groupkey=='Active'}" (click)="dv.filter('Active', 'equals'); groupkey='Active'">Active</button>
                      <button [ngClass]="{'active':groupkey=='Inactive'}" (click)="dv.filter('Inactive', 'equals'); groupkey='Inactive'">Inactive</button>
                      <button [ngClass]="{'active':groupkey=='Int. Users'}" (click)="dv.filter('N', 'equals'); groupkey='Int. Users'">Internal Users</button>
                      <button [ngClass]="{'active':groupkey=='Ext. Users'}" (click)="dv.filter('Y', 'equals'); groupkey='Ext. Users'">External Users</button>
                      <!-- <button [ngClass]="{'active':groupkey=='Inactive'}"
                        (click)="getAllReportByGroup('Int Users')">Int Users</button>
                      <button [ngClass]="{'active':groupkey=='PROJECT_NUMBER'}"
                        (click)="getAllReportByGroup('Ext Users')">Ext Users</button>
                      <button [ngClass]="{'active':groupkey=='RECENT_DATE'}"
                        (click)="getAllReportByGroup('RECENT_DATE')">My Recent Work</button> -->
                      </span>
                  </span>
                  <!-- <mat-slide-toggle [checked]="includeExternal"
                    (change)="portToggle(); dv.filter(external, 'external')"><span
                      style="color:white; font-weight:bold; margin-left:10px">Include External</span>
                  </mat-slide-toggle> -->
                  <div>
                    <!--<a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-4" style="background:#58a400; color:white"
                      (click)="toggleUser()">
                      Toggle View
                    </a>
                    -->
                    <input type="text" pInputText placeholder="Search" (input)="dv.filter($event.target.value, 'contains')">
                  </div>

                  <!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
                </div>
                <!-- <p-dropdown [options]="sortOptions" [(ngModel)]="sortKey" placeholder="Sort By Price"
                            (onChange)="onSortChange($event)" styleClass="p-mb-2 p-mb-md-0"></p-dropdown> -->
              </ng-template>
              <ng-template let-user pTemplate="listItem">
                <div>
                  {{user.USER_ID}}
                </div>
              </ng-template>
              <ng-template let-user let-i="rowIndex" pTemplate="gridItem">
                <!-- <div class="p-col-12 p-md-3">
                                {{user.USER_ID}} test
                            </div> -->
                <div class="p-col-12 p-md-3">
                  <div class="product-grid-item card" [style.background-color]="(i%8)<4 ? '#4A4A4A':'#FDFFEF'" style="padding:1rem;  margin-bottom:0rem; border:3px;   border-style: solid; border-color:#C3D42F">
                    <div class="mb-2" style="  font-weight: 600; background:#C3D42F; color:black; margin:-1rem; padding:0.5rem">
                      <div class="row">
                        <!-- <div class="col-md-2"> 
                          <a style="cursor:pointer" (click)="changeStatus(user);"> <i
                              class="fas fa-user" [class.erisGreen]="user.STATUS=='Active'"></i></a> 
                            </div> -->
                        <!-- <div class=col-md-1>

                        </div> -->
                        <div class="col-md-12 text-center">
                          <a [title]="user.STATUS" style="cursor:pointer;float:left; text-align:left" (click)="changeStatus(user);"> <i class="fas fa-user" [class.erisGrey]="user.STATUS!='Active'"></i></a>
                          <a [exclude]="'.firstname'" (clickOutside)="user.FIRST_NAME_EDIT=false;" (click)="user.FIRST_NAME_EDIT=true; user.FIRST_NAME_TOEDIT= user.FIRST_NAME" [hidden]="user.FIRST_NAME_EDIT">
                            <span *ngIf="user.FIRST_NAME">{{user.FIRST_NAME}}&nbsp;</span>
                            <span *ngIf="!user.FIRST_NAME">First Name </span>
                          </a>
                          <input (change)="changeUserDetails('FIRST_NAME', user);user.FIRST_NAME_EDIT=false" class="firstname editBox2" style="word-break: break-word;" [hidden]="!user.FIRST_NAME_EDIT" type="text" pInputText [(ngModel)]="user.FIRST_NAME_TOEDIT">
                          <a [exclude]="'.lastname'" (clickOutside)="user.LAST_NAME_EDIT=false;" (click)="user.LAST_NAME_EDIT=true; user.LAST_NAME_TOEDIT= user.LAST_NAME" [hidden]="user.LAST_NAME_EDIT">
                            <span *ngIf="user.LAST_NAME">{{user.LAST_NAME}}</span>
                            <span *ngIf="!user.LAST_NAME">Last Name</span>
                          </a>
                          <input (change)="changeUserDetails('LAST_NAME', user);user.LAST_NAME_EDIT=false" class="lastname editBox2" [hidden]="!user.LAST_NAME_EDIT" type="text" pInputText [(ngModel)]="user.LAST_NAME_TOEDIT">

                          <span style="float:right; text-align:right">{{user.EXTERNAL_USER}}</span>
                        </div>
                        <!-- <div class="col-md-3 text-right">
                          <span style="text-align:right">Ext: {{user.EXTERNAL_USER}}</span>
                        </div> -->
                      </div>
                    </div>
                    <!-- <div class="product-grid-item-content">
                                    <div *ngIf="user.FULL_NAME" class="product-name">{{user.FULL_NAME}}</div>
                                     <div *ngIf="!user.FULL_NAME" class="product-name">Name Required</div>
                                    <div class="product-description">{{user.USER_EMAIL}}</div>
                                  </div> -->
                    <div [style.color]="(i%8)<4 ? '#dedede':'black'" style="font-weight:550">
                      <a style="font-weight:400" [exclude]="'.jobtitle'" (clickOutside)="user.JOB_TITLE_EDIT=false;" (click)="user.JOB_TITLE_EDIT=true; user.JOB_TITLE_TOEDIT= user.JOB_TITLE" [hidden]="user.JOB_TITLE_EDIT">
                        <span style="font-weight:550"> Title:</span>
                        <span *ngIf="user.JOB_TITLE"> {{user.JOB_TITLE}}</span>
                        <!-- <span *ngIf="!user.JOB_TITLE"> <i class="fas fa-pen erisGreen"></i></span> -->
                      </a>
                      <span [hidden]="!user.JOB_TITLE_EDIT">
                        Title:
                        <input (change)="changeUserDetails('JOB_TITLE', user);user.JOB_TITLE_EDIT=false" class="jobtitle editBox" type="text" pInputText [(ngModel)]="user.JOB_TITLE_TOEDIT">
                      </span>
                      <br>
                      <a style="font-weight:400" [exclude]="'.useremail'" (clickOutside)="user.USER_EMAIL_EDIT=false;" (click)="user.USER_EMAIL_EDIT=true; user.USER_EMAIL_TOEDIT= user.USER_EMAIL" [hidden]="user.USER_EMAIL_EDIT">
                        <span style="font-weight:550"> Email:</span>
                        <span *ngIf="user.USER_EMAIL"> {{user.USER_EMAIL}}</span>
                        <!-- <span *ngIf="!user.USER_EMAIL"> <i class="fas fa-pen erisGreen"></i></span> -->
                      </a>
                      <span [hidden]="!user.USER_EMAIL_EDIT">
                        Email:
                        <input (change)="changeUserDetails('USER_EMAIL', user);user.USER_EMAIL_EDIT=false" class="useremail editBox" type="text" pInputText [(ngModel)]="user.USER_EMAIL_TOEDIT">
                      </span>

                      <br>
                      <a style="font-weight:400" [exclude]="'.altemail'" (clickOutside)="user.ALTERNATIVE_EMAIL_EDIT=false;" (click)="user.ALTERNATIVE_EMAIL_EDIT=true; user.ALTERNATIVE_EMAIL_TOEDIT= user.ALTERNATIVE_EMAIL" [hidden]="user.ALTERNATIVE_EMAIL_EDIT">
                        <span style="font-weight:550"> Alt. Email:</span>
                        <span *ngIf="user.ALTERNATIVE_EMAIL"> {{user.ALTERNATIVE_EMAIL}}</span>
                        <!-- <span *ngIf="!user.ALTERNATIVE_EMAIL"> <i class="fas fa-pen erisGreen"></i></span> -->
                      </a>
                      <span [hidden]="!user.ALTERNATIVE_EMAIL_EDIT">
                        Alt. Email:
                        <input (change)="changeUserDetails('ALTERNATIVE_EMAIL', user);user.ALTERNATIVE_EMAIL_EDIT=false" class="altemail editBox" type="text" pInputText [(ngModel)]="user.ALTERNATIVE_EMAIL_TOEDIT">

                      </span>

                      <br>
                      <a style="font-weight:400" [exclude]="'.phone'" (clickOutside)="user.PHONE_NUMBER_EDIT=false;" (click)="user.PHONE_NUMBER_EDIT=true; user.PHONE_NUMBER_TOEDIT= user.PHONE_NUMBER" [hidden]="user.PHONE_NUMBER_EDIT">
                        <span style="font-weight:550"> Phone: </span>
                        <span *ngIf="user.PHONE_NUMBER"> {{user.PHONE_NUMBER}}</span>
                        <!-- <span *ngIf="!user.PHONE_NUMBER"> <i class="fas fa-pen erisGreen"></i></span> -->

                      </a>
                      <span [hidden]="!user.PHONE_NUMBER_EDIT">
                        Phone:
                        <input mask="(000) 000-0000" (change)="changeUserDetails('PHONE_NUMBER', user);user.PHONE_NUMBER_EDIT=false" class="phone editBox" type="text" pInputText [(ngModel)]="user.PHONE_NUMBER_TOEDIT">
                      </span>

                      <br>
                      <span>Resumes:
                        <a style="font-weight:400" (click)="op1.toggle($event)"><i class="fas fa-file-upload erisGreen1"></i></a>
                        <p-overlayPanel #op1 [appendTo]="'body'" [style]="{'width':'300px'}">
                          <input #resume type="file" style="display:none" (change)="getName();" accept=".txt,.docx,.doc,.pdf,.PDF"/>
                          <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px" (click)='selectFile()' aria-label="Recipient's username" aria-describedby="basic-addon2">{{curRptPara.name}}</label>
                          <button type="button" class="btn btn-primary" (click)="addResume(curRptPara, user); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px; background-color:rgb(195,212,47);">Upload</button>
                        </p-overlayPanel>
                        <div class="ml-3" *ngFor="let resume of user.RESUMES; let j=index" style="font-weight:400">
                          <a style="cursor:pointer " class="erisGreen" (click)="showDeleteResumeConfirm(user, resume, i, j)"><i class="fas fa-times"></i></a> &nbsp; <a class="erisGreen" target="_blank" [href]="resume.RESUME_URL">{{resume.RESUME_TITLE}}</a>
                        </div>
                        <br *ngIf="!user.RESUMES[0]">
                      </span>
                      <span>Signature: <a style="font-weight:400" *ngIf="user.SIGNATURE_URL!=''" [href]="user.SIGNATURE_URL" target="_blank"><i class="fas fa-link erisGreen1 m-1"></i></a>
                        <a *ngIf="user.SIGNATURE_URL!=''" style="cursor:pointer" (click)="changeSignature(null, user)"><i class="fas fa-trash erisGreen1 m-1"></i></a>
                        <a style="cursor:pointer" (click)="op3.toggle($event); resetUserForm();"><i class="fas fa-edit erisGreen1 m-1"></i></a></span>
                      <p-overlayPanel #op3 [appendTo]="'body'" [style]="{'width':'300px'}">
                        <input #signature type="file" style="display:none" (change)="getName2();"  accept=".jpeg,.png,.jpg"/>
                        <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px" (click)='selectFile2()' aria-label="Recipient's username" aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                        <button type="button" class="btn btn-primary" (click)="changeSignature(curRptPara2, user); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;">Upload</button>
                      </p-overlayPanel>
                      <br>
                      Role:
                      <a style="cursor:pointer; float:right" (click)="deleteUser(user, i)"><i class="fas fa-trash erisGreen1"></i></a>
                    </div>
                  </div>
                </div>
              </ng-template>
              <!-- <ng-template pTemplate="footer">Choose from the list.</ng-template> -->
            </p-dataView>
            <div *ngIf="!userview">
              <p-table #pt styleClass="p-datatable-sm" [value]="usersList" [columns]="cols" [paginator]="true" [rows]="75" [globalFilterFields]="['FULL_NAME','FIRST_NAME','LAST_NAME','USER_EMAIL', 'ALTERNATE_EMAIL', 'PHONE_NUMBER','JOB_TITLE','STATUS']">
                <ng-template pTemplate="caption">
                  <!-- Users
                  <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                  data-toggle="modal" data-target="#reportsModal2">

                  Add New User
                </a>
                  <a   class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" (click)="toggleUser()">
                    Toggle View
                  </a> -->
                  <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                    <span>
                      {{totalUsers}} Users
                      <i *ngIf="usersLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

                      <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:rgb(195,212,47); color:black" data-toggle="modal" data-target="#reportsModal2"
                        (click)="newUser=true;resetUserForm();changeRole();checkManageUsersPermission(null);">
                        <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                        Add New User
                      </a>
                      <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:rgb(195,212,47); color:black" data-toggle="modal" data-target="#import"
                        (click)="resetUpload();checkUploadBatchUsersPermission()">
                        Add Batch Users
                      </a>
                      <!--a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:rgb(195,212,47); color:black" (click)="getErrorUploadUsers()">
                        Get Error Upload Users
                      </a-->
                      <span style="padding: 5px; color: white; font-size:12px">
                        <!--Filter By :
                        <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" [ngClass]="{'active':groupkey=='All'}" (click)=" resetTableFilters(pt); groupkey='All'">All</button>
                        <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" [ngClass]="{'active':groupkey=='Active'}" (click)="resetTableFilters(pt); pt.filter('Active', 'STATUS', 'equals'); groupkey='Active'">Active</button>
                        <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" [ngClass]="{'active':groupkey=='Inactive'}" (click)="resetTableFilters(pt); pt.filter('Inactive', 'STATUS', 'equals'); groupkey='Inactive'">Inactive</button>
                        <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" [ngClass]="{'active':groupkey=='Int. Users'}" (click)="resetTableFilters(pt); pt.filter('N', 'EXTERNAL_USER', 'equals'); groupkey='Int. Users'">Internal Users</button>
                        <button class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" [ngClass]="{'active':groupkey=='Ext. Users'}" (click)="resetTableFilters(pt);pt.filter('Y', 'EXTERNAL_USER', 'equals'); groupkey='Ext. Users'">External Users</button-->
                        <button *ngIf="companyUsersBounded" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" (click)="getErrorUploadUsers()">Show Failed User Upload</button>
                        <button *ngIf="errorUserListBounded"class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="color: white; border: 1px solid white" (click)="getErrorUploadUsers()">Show Company Users</button>

                        <!-- <button [ngClass]="{'active':groupkey=='Inactive'}"
                        (click)="getAllReportByGroup('Int Users')">Int Users</button>
                      <button [ngClass]="{'active':groupkey=='PROJECT_NUMBER'}"
                        (click)="getAllReportByGroup('Ext Users')">Ext Users</button>
                      <button [ngClass]="{'active':groupkey=='RECENT_DATE'}"
                        (click)="getAllReportByGroup('RECENT_DATE')">My Recent Work</button> -->
                        <i *ngIf="loading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>
                      </span>
                    </span>
                    <!-- <mat-slide-toggle [checked]="includeExternal"
                      (change)="portToggle(); pt.filterGlobal(external, 'external')"><span
                        style="color:white; font-weight:bold; margin-left:10px">Include External</span>
                    </mat-slide-toggle> -->
                    <div>
                      <!--
                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-4" style="background:#58a400; color:white"
                        (click)="toggleUser()">
                        Toggle View
                      </a>
                      -->
                      <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white" (input)="pt.filterGlobal($event.target.value, 'contains')">
                    </div>

                    <!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
                  </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                  <!-- <th *ngIf="showihtable"
                  [ngStyle]="{'width': '20%', 'padding': '0.4em'}">Street Name
                
                  </th> -->
                  <tr style="font-size:12px !important">
                    <th *ngFor="let col of columns; let i = index" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                      {{col.header}}
                      <span *ngIf="col.field=='USER_EMAIL'"><br>(Alt Email) </span>
                      <p-sortIcon *ngIf="companyUsersBounded" [field]="col.field"></p-sortIcon>
                      <p-sortIcon *ngIf="errorUserListBounded&&i!=0" [field]="col.field"></p-sortIcon>

                    </th>
                  </tr>
                  <tr>
                    <th *ngFor="let col of columns|slice:0:14; let i = index"style="padding:2px;border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                    <!--span *ngIf="col.field!='CHECKBOX'"-->
                    
                    <input  *ngIf="companyUsersBounded==true&&i!=5&&i!=6&&i!=7&&(!companyGroupIndicator||(companyGroupIndicator&&i!=11))"pInputText type="text"
                      (input)="pt.filter($event.target.value, col.searchField, 'contains');consoleLog($event.target.value); consoleLog(col.searchField)"
                      style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px; color: white">
                      <input  *ngIf="companyUsersBounded==true&&companyGroupIndicator&&i==11" pInputText type="text"
                      (input)="pt.filter($event.target.value, 'groupnames', 'contains');consoleLog($event.target.value); consoleLog(groupnames)"
                      style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px; color: white">
                      <input  *ngIf="errorUserListBounded&&i!=0"pInputText type="text"
                      (input)="pt.filter($event.target.value, col.searchField, 'contains');consoleLog($event.target.value); consoleLog(col.searchField)"
                      style="margin:0 2px; font-size:12px; width:98%; background-color: rgb(9 17 33); border: 0px; color: white">
                    <!--/span-->
                    </th>
                      </tr>
                </ng-template>
                <ng-template pTemplate="body" let-car let-i="rowIndex" let-columns="columns">
                  <tr style="font-size:12px !important; word-break: break-all;">
                    <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                      <!-- <span class="line-clamp1"  *ngIf="col.field!='SIGNATURE_URL' && col.field!='RESUMES'">{{car[col.field]}} </span> -->
                      <!-- <a title="Invite User" *ngIf="col.field=='EDIT'" style="cursor:pointer;" class="m-1"> -->
                      <a *ngIf="col.field=='EDIT'" style="cursor:pointer;" class="m-1">
                        <i style="font-size:15px; color: rgb(201 218 251)" data-toggle="modal" data-target="#reportsModal2"
                          (click)="newUser=true;fillUser(car);changeRolesList();checkManageUsersPermission(col.USER_ID);" class="fas fa-edit"></i>
                      </a>

                      <span *ngIf="col.field!='GROUPS' && col.field!='STATUS' && col.field!='RESUMES'&&col.field!='SIGNATURE_URL'&& col.field!='SEAL_URL' && col.field!='ERIS_USERNAME' && col.field!='USER_EMAIL' && col.field!='ROLE_NAME' && col.field!='PHONE_NUMBER' && col.field!='ALTERNATIVE_EMAIL'">
                        <div style="max-width:calc(100%);" class="line-clamp">
                          <a [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis;">
                            {{car[col.field]}}
                          </a>
                        </div>
                      </span>

                      <span *ngIf="col.field=='GROUPS'">
                        <div *ngIf="car.GROUPS">
                          <a style="float:right; cursor:pointer;"  *ngIf="car[col.field]&&car[col.field].length>3" title="View All" (click)="car.SHOWALL=!car.SHOWALL;">
                            <i *ngIf="!car.SHOWALL" class='fas fa-chevron-right'></i>
                            <i *ngIf="car.SHOWALL" class='fas fa-chevron-down'></i>
                          </a>
                          <div *ngFor="let group of car[col.field]; let k=index; trackBy: trackByFuntion">
                            <span *ngIf="k<3 || car.SHOWALL" [title]="label" style="display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                              {{group.GROUP_NAME}}
                            </span>
                          </div>
                        </div>
                      </span>

                      <ng-container *ngIf="col.field=='PHONE_NUMBER'">
                        <div style="position:relative">
                          <div style="max-width:calc(100%);" class="line-clamp">
                            <a [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis;">
                              {{phoneForm(car[col.field])}}
                            </a>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="col.field=='ROLE_NAME'">
                        <div style="position:relative">
                          <div style="max-width:calc(100% - 20px);" class="line-clamp">
                            <a [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis; white-space: nowrap;">
                              {{car[col.field]}}
                            </a>
                          </div>
                        </div>
                        <p-overlayPanel #op1 [appendTo]="'body'">
                          <ng-template pTemplate>
                            <ng-container *ngFor="let type of roles">
                              <a href="javascript:void(0)" style="font-size:.8em; color: #C2D63F;" (click)="car[col.field]=type.ROLE_NAME; role=type.ROLE_ID; updateRole(type, car); op1.hide()">
                                {{type.ROLE_NAME}}
                              </a>
                              <br>
                            </ng-container>
                          </ng-template>
                        </p-overlayPanel>
                      </ng-container>

                      <span *ngIf="col.field=='ERIS_USERNAME'">
                        <span *ngIf="car[col.field]">{{car[col.field]}} </span>
                        <a data-toggle="modal" data-target="#ERISModal" style="float:right;cursor: pointer;" (click)="erisRowData=car; E_PASSWORD=''; E_USERNAME='';" *ngIf="!car[col.field]">
                          <i class='fas fa-link erisIconColor'></i>
                        </a>
                      </span>
                      <!--
                        <span *ngIf="col.field=='EDIT'">
                        <a style="cursor: pointer; text-decoration: underline; margin-right:10px;" data-toggle="modal"
                          data-target="#reportsModal2"
                          (click)="resetUserForm(); fillUser(car); newUser=false; userEditId=car.USER_ID; userRemoveIndex=i;"><i
                            class="fas fa-edit erisGreen"></i></a>
                      -->
                      <ng-container *ngIf="col.field=='USER_EMAIL'">
                        <div style="position:relative">
                          <div style="max-width:calc(100% - 20px);" class="line-clamp">
                            <a [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis; white-space: nowrap;">
                              {{car.USER_EMAIL}}


                            </a><br>
                            <a *ngIf="car.ALTERNATIVE_EMAIL" [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis; white-space: nowrap;">
                              ({{car.ALTERNATIVE_EMAIL}})
                            </a>
                          </div>
                          <div>
                            <span *ngIf="companyUsersBounded">
                            <a title="Edit" style="position:absolute;right:0;top:-5px; cursor: pointer; transform: translateY(5px);" data-toggle="modal" data-target="#reportsModal2" 
                              (click)="checkManageUsersPermission(car.USER_ID); fillUser(car); newUser=false; changeRolesList(); userEditId=car.USER_ID; userRemoveIndex=i;">
                              <i class="fas fa-edit erisIconColor"></i>
                            </a>
                            </span>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="col.field=='ALTERNATIVE_EMAIL'">
                        <div style="position:relative">
                          <div style="max-width:calc(100% - 20px);" class="line-clamp">
                            <a [title]="car[col.field]" style="cursor: pointer; margin-right:19px; overflow: ellipsis; white-space: nowrap;">
                              {{car[col.field]}}
                            </a>
                          </div>
                          <!--
                            <div>
                          <a title="Edit" style="position:absolute;right:0;top:-5px; cursor: pointer;" data-toggle="modal"
                          data-target="#reportsModal2"
                          (click)="resetUserForm(); fillUser(car); newUser=false; userEditId=car.USER_ID; userRemoveIndex=i;"><i
                            class="fas fa-edit erisGreen"></i></a>
                          </div>
                          -->
                        </div>
                      </ng-container>
                      <span *ngIf="col.field=='STATUS'">
                        <a>{{car[col.field]}}</a>
                        <a title="Change status" style="cursor:pointer;  margin-left:10px;" *ngIf="car.STATUS=='Active'" (click)=changeStatus(car)>
                          <i class="erisIconColor fas fa-toggle-on"></i>
                        </a>
                        <a title="Change status" style="cursor:pointer;  margin-left:10px;" *ngIf="car.STATUS!='Active'" (click)=changeStatus(car)>
                          <i class="erisIconColor fas fa-toggle-off"></i>
                        </a>
                      </span>

                      <span class="line-clamp1" *ngIf="col.field=='SIGNATURE_URL'">
                        <!-- <a target="_blank" *ngIf="car[col.field]" [href]="car[col.field]"><i class="fas fa-link erisGreen"></i></a> -->
                        <a style="font-weight:400;color:rgb(195,212,47)" *ngIf="car.SIGNATURE_URL!=''" [href]="car.SIGNATURE_URL" target="_blank">Signature</a>
                        <a *ngIf="car.SIGNATURE_URL==''" style="cursor:pointer; float:right" (click)="op1.toggle($event); resetUserForm();"><i class="fas fa-edit erisIconColor m-1"></i></a>
                        <p-overlayPanel #op1 [appendTo]="'body'">
                          <input #signature type="file" accept=".jpeg,.png,.jpg" style="display:none; overflow: hidden; max-width: 100%;" (change)="getName2();">
                          <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile2()' aria-label="Recipient's username" [title]="curRptPara2.name" aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                          <button type="button" class="btn btn-primary erisGreen1" (click)="changeSignature(curRptPara2, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px; background:rgb(201 218 251); color:black; transform: translateY(-16px);">Upload</button>
                          <div style="font-size:11px">
                          Signature image should be at least (but not exceed) 300 x 100 pixels (width x height).
                          </div>
                          <div style="font-size:11px">
                            We accept jpeg, png, and jpg formats.
                          </div>
                        </p-overlayPanel>

                        <!-- <a *ngIf="car.SIGNATURE_URL!=''" style="cursor:pointer"
                                (click)="changeSignature(null, car)"><i class="fas fa-trash erisGreen m-1"></i></a> -->

                        <a *ngIf=" car.SIGNATURE_URL!=''" style="font-weight:400; float:right" (click)="op2.toggle($event)">
                          <i class="fas fa-chevron-down"></i>
                        </a>

                        <p-overlayPanel #op2 [appendTo]="'body'">
                          <a *ngIf="car.SIGNATURE_URL!=''" style="cursor:pointer" (click)="changeSignature(null, car)"><i class="fas fa-trash erisIconColor m-1"></i></a>

                          <a style="cursor:pointer" (click)="op1.toggle($event); resetUserForm();"><i class="fas fa-edit erisIconColor m-1"></i></a>
                          <p-overlayPanel #op1 [appendTo]="'body'" [style]="{'width':'300px'}">
                            <input #signature type="file" accept=".jpeg,.png,.jpg" style="display:none" (change)="getName2();" />
                            <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile2()' aria-label="Recipient's username" aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                            <button type="button" class="btn btn-primary" (click)="changeSignature(curRptPara2, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;">Change</button>
                          </p-overlayPanel>
                        </p-overlayPanel>
                      </span>

                      <span class="line-clamp1" *ngIf="col.field=='SEAL_URL'">

                        <!-- <a target="_blank" *ngIf="car[col.field]" [href]="car[col.field]"><i class="fas fa-link erisGreen"></i></a> -->
                        <a style="font-weight:400;color:rgb(195,212,47)" *ngIf="car.SEAL_URL!=''" [href]="car.SEAL_URL" target="_blank">Seal</a>
                        <a *ngIf="car.SEAL_URL==''" style="cursor:pointer; float:right" (click)="op1.toggle($event); resetUserForm();"><i class="fas fa-edit erisIconColor"></i></a>
                        <p-overlayPanel #op1 [appendTo]="'body'">
                          <input #signature type="file" accept=".jpeg,.png,.jpg" style="display:none" (change)="getName2();" />
                          <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile2(); ' aria-label="Recipient's username" [title]="curRptPara2.name" (change)="checkFile(curRptPara2)" aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                          <button type="button" class="btn btn-primary" [disabled]='!fileType' (click)="changeSeal(curRptPara2, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;  background:rgb(201 218 251);  color:black; transform: translateY(-16px);">Upload</button>
                          <div style="font-size:11px">
                            Seal/Stamp image should not exceed 200 x 200 pixels (width x height). 
                            </div>
                            <div style="font-size:11px">
                              We accept jpeg, png and jpg formats.
                            </div>
                          <span *ngIf="!fileType" style="color: red;">
                            Wrong File Type
                          </span>
                        </p-overlayPanel>

                        <!-- <a *ngIf="car.SIGNATURE_URL!=''" style="cursor:pointer"
                                (click)="changeSignature(null, car)"><i class="fas fa-trash erisGreen m-1"></i></a> -->

                        <a *ngIf=" car.SEAL_URL!=''" style="font-weight:400; float:right" (click)="op2.toggle($event)">
                          <i class="fas fa-chevron-down"></i>
                        </a>

                        <p-overlayPanel #op2 [appendTo]="'body'">
                          <a *ngIf="car.SEAL_URL!=''" style="cursor:pointer" (click)="changeSeal(null, car)"><i class="fas fa-trash erisGreen1 m-1"></i></a>

                          <a style="cursor:pointer" (click)="op1.toggle($event); resetUserForm();"><i class="fas fa-edit erisGreen1 m-1"></i></a>
                          <p-overlayPanel #op1 [appendTo]="'body'" [style]="{'width':'300px'}">
                            <input #signature type="file" accept=".jpeg,.png,.jpg" style="display:none" (change)="getName2();" />
                            <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile2()' aria-label="Recipient's username" aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                            <button type="button" class="btn btn-primary" (click)="changeSeal(curRptPara2, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;">Change</button>
                          </p-overlayPanel>
                        </p-overlayPanel>
                      </span>
                      <span *ngIf="col.field=='RESUMES'">
                        <div class="line-clamp">
                          <span *ngIf="car.RESUMES && car.RESUMES[0]">
                            <a style="color:rgb(195,212,47);cursor: pointer; margin-right:19px; text-overflow: ellipsis; " target="_blank" [href]="car.RESUMES[0].RESUME_URL" [title]="car.RESUMES[0].RESUME_TITLE">{{car.RESUMES[0].RESUME_TITLE}}</a>

                          </span>
                        </div>
                        <span *ngIf="car.RESUMES">
                        <div style="transform: translateY(-16px);">
                          <a *ngIf="car.RESUMES.length==1" style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i class="fas fa-file-upload erisIconColor"></i></a>
                        </div>
                        <a *ngIf="car.RESUMES.length==0" style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i class="fas fa-file-upload erisIconColor"></i></a>
                        <a *ngIf="car.RESUMES.length>=2" style="font-weight:400; float:right;cursor:pointer" (click)="op2.toggle($event)"><i class="fas fa-chevron-down"></i></a>
                      </span>
                        <p-overlayPanel #op1 [appendTo]="'body'" [style]="{'width':'300px'}">
                          <input #resume type="file" style="display:none" (change)="getName();"  accept=".txt,.docx,.doc,.pdf,.PDF"/>
                          <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile()' aria-label="Recipient's username" [title]="curRptPara.name" aria-describedby="basic-addon2">{{curRptPara.name}}</label>
                          <button type="button" class="btn btn-primary" (click)="addResume(curRptPara, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px;background:rgb(201 218 251); color:black; transform: translateY(-16px);">Upload</button>
                        </p-overlayPanel>
                        <p-overlayPanel #op2 [appendTo]="'body'">
                          <div *ngFor="let resume of car.RESUMES; let j=index" style="font-weight:400">
                            <input type="checkbox" [checked]="resume.DEFAULT_RESUME=='Y'" (change)="setDefaultResume($event, resume, car.RESUMES, j)"> &nbsp;<a style="color:rgb(195,212,47)" target="_blank" [href]="resume.RESUME_URL">{{resume.RESUME_TITLE}}</a> &nbsp; <a style="cursor:pointer " class="erisGreen1" (click)="showDeleteResumeConfirm(car, resume, i, j)"><i class="fas fa-times"></i></a> 
                          </div>
                          <!-- <a style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i
                                class="fas fa-file-upload erisGreen m-1"></i></a> -->
                          <input #resume type="file" style="display:none" (change)="getName();"   accept=".txt,.docx,.doc, .pdf,.PDF"/>
                          <label class="form-control" style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" (click)='selectFile()' aria-label="Recipient's username" aria-describedby="basic-addon2">{{curRptPara.name}}</label>
                          <button type="button" class="btn btn-primary" (click)="addResume(curRptPara, car); op1.hide();" style="margin-left: 5px; padding: 3px; font-size: 12px; background:#C2D63F; color:black; transform: translateY(-16px);">Upload</button>
                        </p-overlayPanel>
                      </span>
                      <span class="line-clamp1" *ngIf="col.field=='ROLE_NAME'">
                      </span>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <div id="menu2" class="tab-pane fade"><br>
          <div style="background-color:#333;color:white;">
            <div style="background-color:#333;color:white;">
              <p-dataView [hidden]="!clientview" #dv2 [value]="companyClients" [paginator]="true" [rows]="9" layout="grid" filterBy="CLIENT_FULL_ADDRESS,CLIENT_CITY,CLIENT_COMPANY_NAME,CLIENT_CONTACT_EMAIL,CLIENT_CONTACT_NAME,CLIENT_COUNTRY,CLIENT_POSTALZIP,CLIENT_PROVSTATE">
                <ng-template pTemplate="header">
                  <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                    <span>
                      Clients

                      <!-- <a style="cursor: pointer; text-decoration: underline; margin-left:10px" data-toggle="modal"
                        data-target="#reportsModal" (click)="newClient=true;">
                        <i
                          class="fas fa-user-plus erisGreen"></i>
                        </a> -->
                      <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" data-toggle="modal" data-target="#reportsModal"
                        (click)="newClient=true; resetClientForm();checkManageClientPermission();">
                        <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                        Add New Client
                      </a>
                    </span>
                    <div>

                      <!--
                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-4" style="background:#58a400; color:white"
                        (click)="toggleClient()">
                        Toggle View
                      </a>
                      -->
                      <input type="text" pInputText placeholder="Search" (input)="dv2.filter($event.target.value, 'contains')">
                    </div>
                    <!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
                  </div>
                </ng-template>
                <ng-template let-user pTemplate="listItem">
                  <div>
                    {{user.CLIENT_COMPANY_NAME}}

                  </div>
                </ng-template>
                <ng-template let-user let-i="rowIndex" pTemplate="gridItem">
                  <!-- <div class="p-col-12 p-md-3">
                                    {{user.USER_ID}} test
                                </div> -->
                  <div class="p-col-12 p-md-3">
                    <div class="product-grid-item card" [style.background-color]="(i%8)<4 ? '#4A4A4A':'#FDFFEF'" style="padding:1rem;  margin-bottom:0rem; border:3px;   border-style: solid; border-color:#C3D42F">
                      <div class="mb-2" style="  font-weight: 600; background:#C3D42F; color:black; margin:-1rem; padding:0.5rem">
                        <div class="row">
                          <div class="col-md-2">
                            <i class="fas fa-users" [class.erisGreen1]="true"></i>
                          </div>
                          <div class="col-md-8 text-center">
                            <div *ngIf="user.CLIENT_COMPANY_NAME">{{user.CLIENT_COMPANY_NAME}}</div>
                            <div *ngIf="!user.CLIENT_COMPANY_NAME">Name Required</div>
                          </div>
                          <div class="col-md-2">
                            <a style="cursor: pointer; text-decoration: underline; margin-left:10px" data-toggle="modal" data-target="#reportsModal" (click)="fillClient(user); newClient=false;  clientId=user.CLIENT_ID; clientRemoveIndex=i;"><i class="fas fa-edit erisGreen1"></i></a>
                          </div>
                        </div>
                      </div>
                      <!-- <div class="product-grid-item-content">
                                      <div *ngIf="user.FULL_NAME" class="product-name">{{user.FULL_NAME}}</div>
                                       <div *ngIf="!user.FULL_NAME" class="product-name">Name Required</div>
                                      <div class="product-description">{{user.USER_EMAIL}}</div>
                                    </div> -->
                      <div>
                        Company Address:
                        <div style="margin-left:15px">
                          {{user.CLIENT_FULL_ADDRESS}}
                          <br *ngIf="user.CLIENT_FULL_ADDRESS!=''">
                          {{user.CLIENT_ADDRESS_LINE1}}
                          <br *ngIf="user.CLIENT_ADDRESS_LINE1!=''">
                          {{user.CLIENT_ADDRESS_LINE2}}
                          <br *ngIf="user.CLIENT_ADDRESS_LINE2!=''">
                          {{user.CLIENT_CITY}}<span *ngIf="user.CLIENT_CITY && (user.CLIENT_PROVSTATE || user.CLIENT_POSTALZIP)">,
                          </span>{{user.CLIENT_PROVSTATE}}
                          <span *ngIf="user.CLIENT_PROVSTATE && (user.CLIENT_POSTALZIP)">,
                          </span>{{user.CLIENT_POSTALZIP}}
                          <br *ngIf="user.CLIENT_CITY!='' || user.CLIENT_PROVSTATE!='' || user.CLIENT_POSTALZIP">
                          <!-- <span *ngIf= "user.RESUMES[0]">Resumes: {{user.RESUMES[0].RESUME_URL}} </span> -->
                        </div>
                        Main Contact:
                        <div style="margin-left:15px">

                          {{user.CLIENT_CONTACT_NAME}}
                          <br *ngIf="user.CLIENT_CONTACT_NAME!=''">
                          {{user.CLIENT_CONTACT_EMAIL}}
                          <br *ngIf="user.CLIENT_CONTACT_EMAIL!=''">
                          {{user.CLIENT_CONTACT_PHONE}}
                        </div>
                        <!-- <a style="cursor:pointer; float:right" (click)="deleteClient(user, i)"><i
                            class="fas fa-trash erisGreen"></i></a> -->
                      </div>
                    </div>
                  </div>
                </ng-template>
                <!-- <ng-template pTemplate="footer">Choose from the list.</ng-template> -->
              </p-dataView>

              <div [hidden]="clientview">
                <p-table #pt3 styleClass="p-datatable-sm" [value]="companyClients" [columns]="clientCols" [paginator]="true" [rows]="75">
                  <ng-template pTemplate="caption">
                    <!-- Users
                    <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                    data-toggle="modal" data-target="#reportsModal2">
  
                    Add New User
                  </a>
                    <a   class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white" (click)="toggleUser()">
                      Toggle View
                    </a> -->
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                      <span>
                        {{totalClients}} Clients

                        <!-- <a style="cursor: pointer; text-decoration: underline; margin-left:10px" data-toggle="modal"
                          data-target="#reportsModal" (click)="newClient=true;">
                          <i
                            class="fas fa-user-plus erisGreen"></i>
                          </a> -->
                          <i *ngIf="clientsLoading" class="pi pi-spin pi-spinner" style="font-size: 1.2rem; margin-left: 10px; color: #C2D63F;"></i>

                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:rgb(195,212,47); color:black" data-toggle="modal" data-target="#reportsModal"
                          (click)="newClient=true;resetClientForm();checkManageClientPermission();">
                          <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                          Add New Client
                        </a>
                        <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4"  style="background:rgb(195,212,47); color:black" data-toggle="modal" data-target="#import1" (click)="resetUpload();checkUploadBatchClientPermission()">
                          <!-- <i class="fas fa-user-plus erisGreen"></i> -->
                          Upload Batch Client
                        </a>
                      </span>
                      <div>
                        <!--
                           <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-4" style="background:#58a400; color:white"
                          (click)="toggleClient()">
                          Toggle View
                        </a>
                        -->
                        <input type="text" pInputText placeholder="Search" style="background-color: rgb(28 36 51); padding: 3px; border: 0px; color: white" (input)="pt3.filterGlobal($event.target.value, 'contains')">
                      </div>
                      <!-- <p-dataViewLayoutOptions></p-dataViewLayoutOptions> -->
                    </div>
                  </ng-template>
                  <ng-template pTemplate="header" let-columns>

                    <tr style="font-size:12px">
                      <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
                    <tr style="font-size:12px;">
                      <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:4px; font-size:12px; border: 2px solid rgb(9 17 33); background-color: rgb(28 36 51)">
                        <span class="line-clamp1" *ngIf="col.field!='CLIENT_FULL_ADDRESS'  &&col.field!='EDIT' && col.field!='STATUS'">{{user[col.field]}}
                        </span>
                        <span *ngIf="col.field=='STATUS'">
                          {{user.STATUS}}
                          <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS=='Active'" (click)=changeClientStatus(user)>
                            <i class="erisIconColor fas fa-toggle-on"></i>
                          </a>
                          <a title="Change status" style="cursor:pointer; float:right" *ngIf="user.STATUS!='Active'" (click)=changeClientStatus(user)>
                            <i class="erisIconColor fas fa-toggle-off"></i>
                          </a>
                        </span>
                        <span *ngIf="col.field=='EDIT'">
                          <a style="cursor: pointer; text-decoration: underline; margin-right:10px;" data-toggle="modal" data-target="#reportsModal"
                          (click)="fillClient(user); newClient=false; clientId=user.CLIENT_ID; clientRemoveIndex=i; checkManageClientPermission();"><i class="fas fa-edit erisIconColor"></i></a>
                        </span>

                        <span class="line-clamp1" *ngIf="col.field=='CLIENT_FULL_ADDRESS' && user.CLIENT_FULL_ADDRESS">
                          <a [title]="user.CLIENT_FULL_ADDRESS" class="link-light line-clamp" style="cursor:pointer; text-decoration: underline;" (click)="op.toggle($event); getCords(user)">
                            <i class="fas fa-map-marker-alt erisIconColor" style="float:right; margin:3px"></i>
                            {{user.CLIENT_FULL_ADDRESS}}
                          </a>
                          <p-overlayPanel #op [appendTo]="'body'" [dismissable]="true" [style]="{width: '550px', height: '550px'}" (onHide)="onHide()">
                            <span style="color:rgb(195,212,47)"> {{user.CLIENT_FULL_ADDRESS}}
                            </span>
                            <span *ngIf="!noLocation" style="color: red;">
                              (Address not found)
                            </span><br>
                            <!--<agm-map id="test" class="googleMap2" controlSize=24 [latitude]="user.lat" [longitude]="user.long" [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false">
                              <agm-marker *ngIf="noLocation" [latitude]="user.lat" [longitude]="user.long">
                                <agm-info-window>
                                  <strong>
                                    <span style="color:rgb(195,212,47)">
                                      {{user.CLIENT_FULL_ADDRESS}}
                                    </span>
                                  </strong>
                                </agm-info-window>
                              </agm-marker>
                            </agm-map>-->
                            <div id="googleMap2" class="googleMap2"></div>
                          </p-overlayPanel>
                        </span>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER: -->
    <app-footer></app-footer>

    <div id="ERISModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

      <div class="modal-dialog modal-dialog-centered" style="max-width:30%">
        <div class="modal-content" style="background-color:#cDcDcD">

          <div class="modal-header">
            <h6 class="modal-title">Link To ERIS</h6>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>

          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <label class=col-md-4 style="font-weight:normal">
                    Username:
                  </label><input class="col-md-5" style="padding:0px" type="text" [(ngModel)]="E_USERNAME">
                </div>
                <div class="col-md-12">

                  <label style="font-weight:normal" class=col-md-4>
                    Password:
                  </label>
                  <input class="col-md-5" type="password" style="padding:0px" [(ngModel)]="E_PASSWORD">
                  <button class="btn btn-gray1 float-right mt-2" (click)="verifyEris();">Verify ERIS Account</button>
                </div>
                <div class="col-md-12" *ngIf="incorrect.length>0" style="color:red">
                  {{incorrect}}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="reportsModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 *ngIf="newClient" class="modal-title w-100 font-weight-bold">Add New Client</h4>
            <h4 *ngIf="!newClient" class="modal-title w-100 font-weight-bold">Edit Client</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <form [formGroup]="form">
              <div class="md-form mb-3">
                <label data-error="wrong" data-success="right" for="defaultForm-email">Company Name: <span style="color:red" *ngIf="(!form.controls.companyName.pristine && !form.controls.companyName.valid)|| !form.value.companyName">
                    *</span></label>
                <input [class.invalid]="!form.controls.companyName.pristine && !form.controls.companyName.valid" formControlName="companyName" id="defaultForm-pass" class="form-control validate rptInfo">
              </div>

              <div class="md-form mb-3">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Contact Name:</label>
                <input class="form-control validate rptInfo" [(ngModel)]="contactName" [ngModelOptions]="{standalone: true}">

              </div>
              <div class="md-form mb-3">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Contact Title:</label>
                <input class="form-control validate rptInfo" [(ngModel)]="contactTitle" [ngModelOptions]="{standalone: true}">

              </div>
              <div class="md-form mb-3">
                <!-- <label data-error="wrong" data-success="right" for="defaultForm-pass">Company Address:</label>
                <input class="form-control validate rptInfo" [(ngModel)]="address"
                  [ngModelOptions]="{standalone: true}"> -->
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Company Address:</label>
                <div class="container">
                  <div class="row">
                    <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="clientAddress" placeholder="Address1" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="clientAddress2" placeholder="Address2" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-5" [(ngModel)]="clientCity" placeholder="City" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo offset-md-2 col-md-5 mb-3" [(ngModel)]="clientState" placeholder="State/Province" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-5" [(ngModel)]="clientZip" placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo offset-md-2 col-md-5 mb-3" [(ngModel)]="clientCountry" placeholder="Country" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="md-form mb-3">
                <!-- remove phone number check:
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Phone (Number Only): <span style="color:red" *ngIf="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid">
                    *</span></label>
                <input mask="(000) 000-0000" placeholder="Number Only" [class.invalid]="!form.controls.clientPhone.pristine && !form.controls.clientPhone.valid" formControlName="clientPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner"> -->
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Phone:</label>
                <input formControlName="clientPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
              </div>
              <div class="md-form mb-3">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Email: <span style="color:red" *ngIf="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid"> *</span></label>
                <input [class.invalid]="!form.controls.clientEmail.pristine && !form.controls.clientEmail.valid" formControlName="clientEmail" id="defaultForm-pass" class="form-control validate rptInfo" (change)="show(form.value.clientEmail)">
              </div>
            </form>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button *ngIf="newClient" [disabled]="!form.valid||!manageClientPermission" (click)="addClient();" class="btn btn-default btn-outline-dark">Add
              Client</button>
            <button *ngIf="!newClient" [disabled]="!form.valid||!manageClientPermission" (click)="changeClient();" class="btn btn-default btn-outline-dark">Change
              Client</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" #companyModal id="companyModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 *ngIf="newCompany" class="modal-title w-100 font-weight-bold">Add New Office Location</h4>
            <h4 *ngIf="!newCompany" class="modal-title w-100 font-weight-bold">Edit Office Location</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearCompanyLocation()">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <form [formGroup]="form">

              <div class="md-form mb-3">
                <div class="container">
                  <div class="row">
                    <label style="margin-left:-15px" class="col-md-6" data-error="wrong" data-success="right" for="defaultForm-email">Office Location:</label>
                    <div class="col-md-6 text-right">
                      <label data-error="wrong" data-success="right" for="defaultForm-pass">Head Office:</label>
                      <label style="margin-left:10px" class="switch">
                        <input type="checkbox" [(ngModel)]="headOffice" [ngModelOptions]="{standalone: true}">
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="locationName" placeholder="Location Name" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress1" placeholder="Address1" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress2" placeholder="Address2" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo col-md-3 mb-3" [(ngModel)]="companyCity" placeholder="City" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo offset-md-1 col-md-3 mb-3" [(ngModel)]="companyState" placeholder="State/Province" [ngModelOptions]="{standalone: true}">
                    <input class="form-control validate rptInfo offset-md-1 col-md-3 mb-3" [(ngModel)]="companyZip" placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
                    <select class="form-control validate rptInfo col-md-3 mb-3" [(ngModel)]="companyCount" [ngModelOptions]="{standalone: true}" style='color: black'>
                      <option value="" disabled selected>
                        Country
                      </option>
                      <option style="color: black;">
                        USA
                      </option>
                      <option style="color: black;">
                        CAN
                      </option>
                      <option style="color: black;">
                        AUS
                      </option>
                    </select>
                    <label style="margin-left:-15px" class="col-md-12" data-error="wrong" data-success="right" for="defaultForm-email">ERIS Branch ID:</label>
                    <input class="form-control validate rptInfo col-md-4" [(ngModel)]="companyERIS" disabled [ngModelOptions]="{standalone: true}">
                    <button (click)="getBranchIds();op333.toggle($event);" title="Select Item"><i class="fas fa-chevron-down" style="pointer-events:none; color:#C2D63F"></i></button>
                    <p-overlayPanel #op333 [appendTo]="companyModal" [dismissable]="true" [style]="{'width': '500px'}">
                      <ng-template pTemplate>
                        <div style="margin:0; max-height:400px; padding:4px 0; width:500px; overflow:auto">
                          <div class="listItem1" style="margin:0; width:470px;">
                           <a href="javascript:void(0)" style="color:rgb(195,212,47); margin:2px" (click)="companyERIS=''">None</a> 
                          </div>                         
                          <ng-container *ngFor="let branch of branches; trackBy: trackByFuntion">
                            <div class="listItem1" style="margin:0; width:470px;">
                              <a href="javascript:void(0)" style="color:rgb(195,212,47); margin:2px" (click)="companyERIS=branch.ERIS_BRANCH_ID; getBrahchInfo(branch.ERIS_BRANCH_ID)">({{branch.ERIS_BRANCH_ID}}) {{branch.ADDRESS}}, {{branch.CITY}}, {{branch.PROVSTATE}} {{branch.POSTALZIP}}, {{branch.COUNTRY}}</a><br>
                            </div>
                          </ng-container>
                        </div>																
                      </ng-template>
                    </p-overlayPanel>
                  </div>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button *ngIf="newCompany" (click)="addCompanyLocation()" class="btn btn-default btn-outline-dark">Add
              Location</button>
            <button *ngIf="!newCompany" (click)="changeLocation();" class="btn btn-default btn-outline-dark">Update
              Location</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="groupModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 *ngIf="newGroup" class="modal-title w-100 font-weight-bold">Add New Group</h4>
            <h4 *ngIf="!newGroup" class="modal-title w-100 font-weight-bold">Edit Group</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="clearGroup()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <form [formGroup]="form">

              <div class="md-form mb-3">
                <div class="container">
                  <div class="row">

                    <label>
                      Group Name:
                    </label>
                    <div class="d-flex justify-content-between w-100">
                      <input class="form-control validate rptInfo mb-3" placeholder="Group Name"
                        [(ngModel)]="inputGroupName" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'col-md-10': !newGroup, 'col-md-12': newGroup}">
                      <button *ngIf="!newGroup" (click)="updateCompanyGroupName();"
                        class="btn btn-sm col-md-2 form-control rptInfo">
                        Save
                      </button>
                    </div>


                    <label *ngIf="inputGroupUsers.length > 0">Users in Group:</label>
                    <div *ngIf="inputGroupUsers.length > 0" class="col-md-12 mb-3 rounded"
                        style="background-color: light-gray; max-height: 200px; overflow-y: auto;">
                      <div class="col-md-12">
                        <div *ngFor="let user of inputGroupUsers" class="col-md-12">
                          <i class="fas fa-times iconBtn erisGreen"
                          (click)="newGroup ? removeUserFromNewGroup(user) : removeUserFromGroup(user)"></i>
                          {{user.FULL_NAME? user.FULL_NAME:user.USER_EMAIL}}
                        </div>
                      </div>
                    </div>

                    <label>
                      Add New User:
                    </label>
                    <div class="d-flex justify-content-between w-100 mb-3">
                      <ng-select
                        id="writer reviewer dropdown"
                        class="form-control rptInfo col-md-10"
                        [clearable]="false" 
                        [items]="companyGroupUserList"
                        notFoundText="Not Found"
                        bindLabel="USER_EMAIL"
                        [(ngModel)]="inputGroupSelectedUser"
                        [ngModelOptions]="{standalone: true}">
                        <ng-template ng-label-tmp let-item="item">
                          <span *ngIf="item.FULL_NAME" style="color: black;">
                            {{ item.FULL_NAME + ', ' + '(' + item.USER_EMAIL + ')' }}
                          </span>
                          <span *ngIf="!item.FULL_NAME">
                            {{ '(' + item.USER_EMAIL + ')' }}
                          </span>
                        </ng-template>
                      </ng-select>
                      <button class="btn btn-sm col-md-2 form-control rptInfo" title="Add User"
                        [disabled]="!inputGroupSelectedUser" 
                        (click)="newGroup ? assignUserToNewGroup() : assignUserToGroup()">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </form>
          </div>
          <div *ngIf="newGroup" class="modal-footer d-flex justify-content-center">
            <button (click)="insertCompanyGroup()" class="btn btn-default btn-outline-dark">
              Add Group
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="companySettings" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 class="modal-title w-100 font-weight-bold">Company Settings</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-3">
            <form [formGroup]="form">
              <div class="md-form mb-3">
                <div class="container">
                  <div class="row">
                    <label style="margin-left:-15px" class="col-md-5" data-error="wrong" data-success="right" for="defaultForm-email">Cloud Bucket Name:</label>
                    <input class="form-control validate rptInfo col-md-7 mb-3" style="margin-left:-15px" [(ngModel)]="locationName" [ngModelOptions]="{standalone: true}">
                    <label style="margin-left:-15px" class="col-md-9" data-error="wrong" data-success="right" for="defaultForm-email"> Always Check Progress:</label>

                    <label style="margin-left:10px" class="switch">
                      <input type="checkbox" [(ngModel)]="headOffice" [ngModelOptions]="{standalone: true}">
                      <span class="slider round"></span>
                    </label>
                    <label style="margin-left:-15px" class="col-md-9" data-error="wrong" data-success="right" for="defaultForm-email"> User have same admin access</label>

                    <label style="margin-left:10px" class="switch">
                      <input type="checkbox" [(ngModel)]="headOffice" [ngModelOptions]="{standalone: true}">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button *ngIf="newCompany" (click)="addCompanyLocation()" class="btn btn-default btn-outline-dark">Add
              Location</button>
            <button *ngIf="!newCompany" (click)="changeLocation();" class="btn btn-default btn-outline-dark">Change
              Location</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="newFile" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 *ngIf="!editFile" class="modal-title w-100 font-weight-bold">Add New File</h4>
            <h4 *ngIf="editFile" class="modal-title w-100 font-weight-bold">Edit File</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-2">
            
            <div *ngIf="!editFile" class="md-form mb-1">

              <label data-error="wrong" data-success="right" for="defaultForm-pass">File Type <strong style="color: red">*</strong></label>
              <br>
              <select style="width:100%" class="rptInfo" [(ngModel)]="newFileType">
                <option [value]="type" *ngFor="let type of types">
                  {{type}} </option>

              </select>
            </div>
            <div *ngIf="!editFile" class="md-form mb-1">
              <label data-error="wrong" data-success="right" for="defaultForm-pass">File</label>
              <input multiple="multiple" [disabled]="!newFileType || !uploadNewFilePermission" (change)="uploadNewFile()" #newFile type="file" 
                    accept="{{ newFileType=='IMAGE' || newFileType=='BKIMAGE' || newFileType=='LOGO'? 'image/jpg, image/jpeg, image/png' :'*'}}" 
                    class="form-control validate rptInfo">
              <!-- <a (click)="uploadNewFile()" style="cursor:pointer"> <i class="fas fa-file-upload"></i></a> -->
              <!-- <label data-error="wrong" data-success="right" for="defaultForm-pass">Or Link</label>
            <input type="text" class="form-control validate rptInfo" [(ngModel)]="newFileUrl"
              [ngModelOptions]="{standalone: true}"> -->
            </div>
            <!-- <div class="md-form mb-1">
              <label data-error="wrong" data-success="right" for="defaultForm-pass">File Description</label>
              <textarea type="text" class="form-control validate rptInfo" [(ngModel)]="fileDesc"
                [ngModelOptions]="{standalone: true}"></textarea>
            </div> -->
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button *ngIf="!editFile" [disabled]="!newFileType||!uploadNewFilePermission" (click)="insertCompanyFile()" class="btn btn-default btn-outline-dark">Add New File</button>
            <button *ngIf="editFile" (click)="updateCompanyFile()" class="btn btn-default btn-outline-dark">Update Description</button>
            <div>        
              <i style="color: #757575"> * Only files under 100MB and with filenames of less than 100 characters will upload. </i>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div id="import" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

      <div class="modal-dialog modal-dialog-centered" [style.max-width]="excelJson? '80%':'50%'">
        <div class="modal-content" style="background-color:#cDcDcD">

          <div class="modal-header">
            <h6 *ngIf="sheets.length==0" class="modal-title">Import Excel</h6>
            <nav class="navbar navbar-expand-lg navbar-light p-0" style="background-color: #cdcdcd">

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item" [class.active]="sheet==selectedSheet" *ngFor="let sheet of sheets">
                    <a (click)="resetSheet();selectedSheet=sheet; selectSheet()" class="nav-link" style="background-color: #cdcdcd">
                      <h6 >{{sheet}}</h6>
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>

          <div class="modal-body">
            <p-table [value]="excelJson" [columns]="excelCols">
              <ng-template pTemplate="header" let-columns>
                <tr style="font-size:12px">
                  <th style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns">

                    <select style="color:white; background:#323232; max-width:100%" [(ngModel)]="col.changeHeader" (change)="changeCol();">
                      <option *ngFor="let pre of presetCols" [value]='pre'>
                        {{pre}}
                      </option>
                    </select>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr style="font-size:12px;">
                  <td style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns">
                    <span>
                      {{rowData[col.header]}}
                    </span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
            <div class="input-group col-md-12 justify-content-center text-center mt-1">
              <input [style.max-width]="excelJson? '50%':'80%'" #excelFile class="col-md-9 rptInfo mr-1" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" [(ngModel)]="sheet1" />
              <div class="input-group-append">
                <button title="Upload File" class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2" type="button" (click)='uploadExcel()'><i class="fas fa-file-upload"></i></button>
              </div>
              <span id="spinner" class="fa fa-spinner fa-spin" style="font-size:20px; display:none"></span>
              <span id="inputWarn" class="fas fa-exclamation" style="margin-left:4px;font-size:16px; display:none; color:red"></span>
              <span id="inputSuccess" class="fas fa-check" style="margin-left:4px;font-size:16px; display:none; color:green"></span>
            </div>
            <div class="col-md-12 justify-content-center text-center mt-1">
              <button *ngIf="excelJson" class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2" type="button" (click)='uploadBatchUsers();' [disabled]="!uploadBatchUsersPermission">Invite Users</button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Are you sure you want to
              delete the file?</h5>
            <button type="button" (click)="dismissConfirm($event);" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
            <button type="button" class="btn btn-secondary" (click)="dismissConfirm($event);">Go Back</button>
            <button style="float:right" type="button" class="btn btn-primary" (click)="dismissConfirm($event); deleteFile(toDeleteFile)">Delete</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="updateStyleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <span class="modal-title">Are you sure you will update customized company style?<br />When company Style is customized, report Settings will not be take effective</span>
            <button type="button" (click)="dismissConfirm($event);" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body ">
            <button type="button" class="btn btn-secondary" (click)="dismissConfirm($event);">Go Back</button>
            <button style="float:right" type="button" class="btn btn-primary" (click)="dismissConfirm($event); updateCustomStyle(); htmlShow=false;">Continue to Save</button>
          </div>
        </div>
      </div>
    </div>
    <div cdkDrag  class="modal fade" id="reportsModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background:#D8D8D8">
          <div class="modal-header text-center">
            <h4 *ngIf="newUser" class="modal-title w-100 font-weight-bold">Add New User</h4>
            <h4 *ngIf="!newUser" class="modal-title w-100 font-weight-bold">Edit User</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mx-2">
            <form [formGroup]="userform">
              <div class="md-form mb-1">
                <div *ngIf="newUser" style="float:right">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">External:</label>
                  <label style="margin-left:10px" class="switch">
                    <input type="checkbox" [(ngModel)]="userExternal" (change)="changeRole()" [ngModelOptions]="{standalone: true}">
                    <span class="slider round"></span>
                  </label>
                </div>
                <label data-error="wrong" data-success="right" for="defaultForm-email">First Name:<span style="color:red"> *</span></label>

                <input class="form-control validate rptInfo" [(ngModel)]="firstname" [ngModelOptions]="{standalone: true}" (mousedown)="$event.stopPropagation()">
              </div>

              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Last Name:<span style="color: red"> * </span></label>
                <input class="form-control validate rptInfo" [(ngModel)]="lastname" [ngModelOptions]="{standalone: true}" (mousedown)="$event.stopPropagation()">

              </div>
              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Job Title:</label>
                <input class="form-control validate rptInfo" [(ngModel)]="jobTitle" [ngModelOptions]="{standalone: true}" (mousedown)="$event.stopPropagation()">

              </div>
              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Phone (Number Only):<span style="color:red" *ngIf="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid ">
                    *</span></label>
                    <span *ngIf="phoneNumberValid">
                <input mask="000-000-0000" placeholder="Number Only" [class.invalid]="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid" formControlName="userPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner" (mousedown)="$event.stopPropagation()">
                    </span>
                    <!--span *ngIf="!phoneNumberValid">
                      <input [(ngModel)]="phonenumber" [ngModelOptions]="{standalone: true}" class="form-control validate rptInfo no-spinner">
                          </span-->
              </div>
              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Email: <span style="color:red" *ngIf="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid) || userform.value.userEmail=='' || !userform.value.userEmail">
                    *</span></label>
                <input [class.invalid]="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid)" formControlName="userEmail" id="defaultForm-pass" class="form-control validate rptInfo" (change)="show(form.value.userEmail)" (mousedown)="$event.stopPropagation()">

              </div>

              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Alternate Email: <span style="color:red" *ngIf="!userform.controls.alternate.pristine && !userform.controls.alternate.valid">
                    *</span></label>
                <input [class.invalid]="!userform.controls.alternate.pristine && !userform.controls.alternate.valid" formControlName="alternate" id="defaultForm-pass" class="form-control validate rptInfo" (change)="show(form.value.alternate)" (mousedown)="$event.stopPropagation()">

              </div>
              <div class="md-form mb-1">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Role:<span style="color: red"> * </span></label>
                <select style="width:100%" class="rptInfo" [(ngModel)]="role" [ngModelOptions]="{standalone: true}" (mousedown)="$event.stopPropagation()">
                  <option [value]="type.ROLE_ID" *ngFor="let type of roles">
                    {{type.ROLE_NAME}} </option>

                </select>
              </div>
            </form>
            <input disabled [checked]="userInfo.COMPANY_SSO_IND=='Y'" type="checkbox"><label style="font-size: .8em; color:green">Company login is managed by Auth0</label>
          </div>

          <span>
          <div *ngIf="newUser" class="modal-footer d-flex justify-content-center">
            <!-- <button (click)="addUser();" class="btn btn-default btn-outline-dark" [disabled]="!userform.valid">Add
              User</button> -->
              <div>
            <button (click)="inviteUser();" class="btn btn-default btn-outline-dark" [disabled]="!userform.valid||!manageUsersPermission">Invite User</button>

            <i *ngIf="inviteUserLoading" class="pi pi-spin pi-spinner" style="font-size: 2rem; margin-left: 10px; color: rgb(9 17 33);"></i>
              </div>

          </div>
          </span>

          <div *ngIf="!newUser" class="modal-footer d-flex justify-content-center">
            <button (click)="changeUser(userRemoveIndex);" class="btn btn-default btn-outline-dark" [disabled]="!userform.valid||!manageUsersPermission">Save</button>
          </div>

          <div *ngIf="inviteUserWarn" style="color: red; margin: auto; width: 50%; margin-bottom: 5px; text-align:center;">{{inviteUserWarnMessage}}</div>

        </div>
      </div>
    </div>
    <div *ngIf="htmlShow" id="html-box" class="html-box" cdkDrag [cdkDragDisabled]="dragDisabled">
      <div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em">
        <div style="width: 500px; margin: 10px; padding-right:0; color:white; height:600px">
          <label style="font-size:16px; font-weight:bold">Source Viewer</label>
          <button type="button" style="float:right" (click)="htmlShow=false">&times;</button>
          <textarea class="col-md-12" rows=24 [(ngModel)]="bodyHeadCss" (mouseenter)="setDrag(1)" (mouseout)="setDrag(0)" placeholder="Paste your html code here."></textarea>
          <button (click)="resetCustomStyle(); htmlShow=false;" style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark">Reset</button>
          <button data-toggle="modal" data-target="#updateStyleModal" style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
            [disabled]="!manageReportSettingsPermission">
            Update</button>
        </div>
      </div>
    </div>
    <div *ngIf="signShow" id="html-box" class="html-box" cdkDrag [cdkDragDisabled]="dragDisabled">
      <div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em">
        <div style="width: 500px; margin: 10px; padding-right:0; color:white; height:600px">
          <label style="font-size:16px; font-weight:bold">Source Viewer</label>
          <button type="button" style="float:right" (click)="signShow=false">&times;</button>
          <textarea class="col-md-12" rows=24 [(ngModel)]="selectedSign['SIGNATURE_STYLE_TEMPLATE']" (mouseenter)="setDrag(1)" (mouseout)="setDrag(0)" placeholder="Paste your html code here."></textarea>
          <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark"
            [disabled]="!manageReportSettingsPermission" (click)="upateSignProfile()">Update</button>
        </div>
      </div>
    </div>
    <div *ngIf="newSignShow" id="html-box1" class="html-box1" cdkDrag [cdkDragDisabled]="dragDisabled">
      <div style="margin:0 10px; padding:10px; color:#C2D63F;font-size:.9em">
        <div style="width: 1100px; margin: 10px; padding-right:0; color:white; height:480px">
          <label style="font-size:16px; font-weight:bold">New Signature</label>
          <button type="button" style="float:right" (click)="newSignShow=false">&times;</button>
          <div class="mb-3">
            <span style="font-weight: bold;color:#C2D63F; margin-left: 10px;">Please select Signature Style (*one per template)</span>
            <span *ngIf="showBaseTemplateError" style="color:#f78181;">
              <i class="fas fa-exclamation-circle ml-2"></i> Base Template Required
            </span>
            <ul class="widget-item1-list">
                <li class="item1" *ngFor="let temps of signTemps; let i=index" (click)="newsignProfile.id=temps.SS_TEMPLATE_BASE_ID" [ngClass]="{'active':temps.SS_TEMPLATE_BASE_ID==newsignProfile.id}">
                  <div class="img-wrapper">
                    <a href="javascript:void(0)" ><img [src]="temps.SIGNATURE_STYLE_URL" class="img img-fluid" /></a>
                  </div>
                  <div *ngIf="temps.SIGNATURE_STYLE_NAME.length>0" class="title">                   
                    {{temps.SIGNATURE_STYLE_NAME}}
                  </div>
              </li>
             </ul>
          </div>
          <label>Signature Profile Name:* </label>
          <input class="col-md-3 ml-2" [(ngModel)]="newsignProfile.name" type="text">
          <span *ngIf="showProfileNameError" style="color:#f78181;">
            <i class="fas fa-exclamation-circle ml-2"></i> Profile Name Required
          </span>
          <button style="background-color: #C2D63F; color:black; font-weight:600" class="btn btn-default btn-outline-dark float-md-right"
            [disabled]="!manageReportSettingsPermission" (click)="createNewSignProfile()">
            Create Signature Company Style</button>
        </div>
      </div>
    </div>
  </section>
  <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]" (didClosed)="showLogo = null">
    <ng-container name="body">
      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo' (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>
</div>
<div id="import1" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

  <div class="modal-dialog modal-dialog-centered" [style.max-width]="excelJson? '80%':'50%'">
    <div class="modal-content" style="background-color:#cDcDcD">

      <div class="modal-header">
        <h6 class="modal-title">Import Excel from</h6>
        <!--<nav class="navbar navbar-expand-lg navbar-light p-0" style="background-color: #cdcdcd">

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item" [class.active]="sheet==selectedSheet" *ngFor="let sheet of sheets">
                <a (click)="resetSheet();selectedSheet=sheet; selectSheet()" class="nav-link" style="background-color: #cdcdcd">
                  <h5 >{{sheet}}</h5>
                </a>
              </li>
            </ul>
          </div>
        </nav>-->
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <p-table [value]="excelJson" [columns]="excelCols">
          <ng-template pTemplate="header" let-columns>
            <tr style="font-size:12px">
              <th style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns">

                <select style="color:white; background:#323232; max-width:100%" [(ngModel)]="col.changeHeader" (change)="changeCol();">
                  <option *ngFor="let pre of presetCols3" [value]='pre'>
                    {{pre}}
                  </option>
                </select>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr style="font-size:12px;">
              <td style="padding: 1px; padding-left: 3px;" *ngFor="let col of columns">
                <span>
                  {{rowData[col.header]}}
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div class="input-group col-md-12 justify-content-center text-center mt-1">
          <input [style.max-width]="excelJson? '50%':'80%'" #excelFile1 [disabled]="!uploadBatchClientrsPermission" class="col-md-9 rptInfo mr-1" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" [(ngModel)]="sheet1" />
          <div class="input-group-append">
            <button title="Upload File" class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2" type="button" (click)='uploadExcel1()'><i class="fas fa-file-upload"></i></button>
          </div>
          <span id="spinner" class="fa fa-spinner fa-spin" style="font-size:20px; display:none"></span>
          <span id="inputWarn" class="fas fa-exclamation" style="margin-left:4px;font-size:16px; display:none; color:red"></span>
          <span id="inputSuccess" class="fas fa-check" style="margin-left:4px;font-size:16px; display:none; color:green"></span>
        </div>
        <div class="col-md-12 justify-content-center text-center mt-1">
          <button *ngIf="excelJson" class="btn btn-dark btn-sm pt-0 pb-0 pl-2 pr-2" type="button" (click)='uploadBatchClients();' [disabled]="!uploadBatchClientrsPermission">Add Clients</button>
        </div>
        
      </div>
    </div>
  </div>
</div>
<div id="fmeModal" #fmeModal class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

  <div class="modal-dialog modal-dialog-centered" style="max-width: 60%;height:60vh">
    <div class="modal-content" style="background-color: #4b4b4b">

      <div class="modal-header">
        <h6 class="modal-title" style="color:#ccc">Fannie Mae Data Input Setup</h6>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <div style="width:100%;">
          <ul class="nav nav-tabs" style=" font-size: 12px;">
            <li class="nav-item" style="background: none; border: none;">
            <a class="nav-link" [ngClass]="{'active':showPca=='p1'}" style="border: none;" data-toggle="tab" href="#pca" (click)="toEsa()">ESA Data Input</a>		
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showPca=='pca'}"style="border: none;" data-toggle="tab" href="#esa" (click)="toFme()">PCA Data Input</a>
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showPca=='sra'}"style="border: none;" data-toggle="tab" href="#seismic" (click)="toSeismic()">Seismic Data Input</a>
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showPca=='zone'}"style="border: none;" data-toggle="tab" href="#zone" (click)="toZone()">Zoning Data Input</a>
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content" >
            
            <div id="pca" class="container tab-pane" [ngClass]="{'active':showPca=='p1','fade':showPca!='p1' }" style="width:100%; padding:0; height:60vh; overflow:auto">
              
        <ng-container *ngFor="let f of fmesetupdata">
        <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
          <tr>
            <th colspan="3"  style="background-color: #ccc;color:#202a3c;">{{f['FME CATEGORY']}}</th>
          </tr>
          <ng-container *ngFor="let r of f.FME_QUESTIONS">
            <tr>
              <td style="width:40%">{{r.FME_FIELD_NAME}}</td>
              <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{fmeOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                <a *ngIf="r.FME_FIELD_TYPE!='Selection'" href="javascript:void(0)" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op10.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                <p-overlayPanel #op10 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                  <ng-template pTemplate>
                    <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                    <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                    <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateFme(r)">Remove Selection</button>
                    <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                    <ng-container *ngFor="let slot of filtedSlot">                      
                      <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateFme(r, slot)"><label>{{slot.KEY}}</label>
                      <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op11.toggle($event)"></i><br>
                      <p-overlayPanel #op11 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                        <ng-template pTemplate>
                          <div style="height:140px; overflow: auto;font-size: 12px;">
                            <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                              .<label>{{choice}}</label><br>
                            </ng-container>
                          </div>   
                        </ng-template>
                      </p-overlayPanel>
                     
                    </ng-container>
                  </div>
                  </ng-template>
                </p-overlayPanel>
              </td>
              <td style="width:30%">{{r.FME_HELPFUL_HINTS}}</td>
            </tr>
          </ng-container>
        </table>
      </ng-container>
        
      </div>
      <div id="esa" class="container tab-pane"  [ngClass]="{'active':showPca=='pca','fade':showPca!='pca' }" style="width:100%; padding:0; height:60vh; overflow:auto">
        <ng-container *ngFor="let f of fmePcadata">
          <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
            <tr>
              <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['FME CATEGORY']}}</th>
            </tr>
            <ng-container *ngFor="let r of f.FME_QUESTIONS">
              <tr>
                <td style="width:40%">{{r.FME_FIELD_NAME}}</td>
                <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{fmeOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                  <a  *ngIf="r.FME_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                  <p-overlayPanel #op12 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                    <ng-template pTemplate>
                      <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                      <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                      <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateFme(r)">Remove Selection</button>
                      <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                      <ng-container *ngFor="let slot of filtedSlot" >
                        <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateFme(r, slot)"><label>{{slot.KEY}}</label>
                        <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                        <p-overlayPanel #op13 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                          <ng-template pTemplate>
                            <div style="height:140px; overflow: auto;font-size: 12px;">
                              <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                .<label>{{choice}}</label><br>
                              </ng-container>
                            </div>   
                          </ng-template>
                        </p-overlayPanel>
                       
                      </ng-container>
                    </div>
                    </ng-template>
                  </p-overlayPanel>
                </td>
                <td style="width:30%">{{r.FME_HELPFUL_HINTS}}</td>
              </tr>
            </ng-container>
          </table>
        </ng-container>
           </div>
           <div id="seismic" class="container tab-pane"  [ngClass]="{'active':showPca=='sra','fade':showPca!='sra' }" style="width:100%; padding:0; height:60vh; overflow:auto">
            <ng-container *ngFor="let f of fmeSradata">
              <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                <tr>
                  <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['FME CATEGORY']}}</th>
                </tr>
                <ng-container *ngFor="let r of f.FME_QUESTIONS">
                  <tr>
                    <td style="width:40%">{{r.FME_FIELD_NAME}}</td>
                    <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{fmeOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                      <a  *ngIf="r.FME_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                      <p-overlayPanel #op12 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                        <ng-template pTemplate>
                          <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                          <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                          <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateFme(r)">Remove Selection</button>
                          <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                          <ng-container *ngFor="let slot of filtedSlot" >
                            <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateFme(r, slot)"><label>{{slot.KEY}}</label>
                            <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                            <p-overlayPanel #op13 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                              <ng-template pTemplate>
                                <div style="height:140px; overflow: auto;font-size: 12px;">
                                  <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                    .<label>{{choice}}</label><br>
                                  </ng-container>
                                </div>   
                              </ng-template>
                            </p-overlayPanel>
                           
                          </ng-container>
                        </div>
                        </ng-template>
                      </p-overlayPanel>
                    </td>
                    <td style="width:30%">{{r.FME_HELPFUL_HINTS}}</td>
                  </tr>
                </ng-container>
              </table>
            </ng-container>
               </div>
               <div id="zone" class="container tab-pane"  [ngClass]="{'active':showPca=='zone','fade':showPca!='zone' }" style="width:100%; padding:0; height:60vh; overflow:auto">
                <ng-container *ngFor="let f of fmeZondata">
                  <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                    <tr>
                      <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['FME CATEGORY']}}</th>
                    </tr>
                    <ng-container *ngFor="let r of f.FME_QUESTIONS">
                      <tr>
                        <td style="width:40%">{{r.FME_FIELD_NAME}}</td>
                        <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{fmeOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                          <a  *ngIf="r.FME_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                          <p-overlayPanel #op12 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                            <ng-template pTemplate>
                              <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                              <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                              <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateFme(r)">Remove Selection</button>
                              <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                              <ng-container *ngFor="let slot of filtedSlot" >
                                <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateFme(r, slot)"><label>{{slot.KEY}}</label>
                                <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                                <p-overlayPanel #op13 [appendTo]="fmeModal" [showCloseIcon]="true" [dismissable]="true">
                                  <ng-template pTemplate>
                                    <div style="height:140px; overflow: auto;font-size: 12px;">
                                      <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                        .<label>{{choice}}</label><br>
                                      </ng-container>
                                    </div>   
                                  </ng-template>
                                </p-overlayPanel>
                               
                              </ng-container>
                            </div>
                            </ng-template>
                          </p-overlayPanel>
                        </td>
                        <td style="width:30%">{{r.FME_HELPFUL_HINTS}}</td>
                      </tr>
                    </ng-container>
                  </table>
                </ng-container>
                   </div> 
           <div class="col-md-12 justify-content-center text-center mt-1">
            <button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4" type="button" data-dismiss="modal">Close</button>
          </div>
    </div>
  </div>
      </div>
    </div>
  </div>
</div>
<div id="closerModal" #closerModal class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

  <div class="modal-dialog modal-dialog-centered" style="max-width: 60%;height:60vh">
    <div class="modal-content" style="background-color: #4b4b4b">

      <div class="modal-header">
        <h6 class="modal-title" style="color:#ccc">Closer Data Input Setup</h6>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <div style="width:100%;">
          <ul class="nav nav-tabs" style=" font-size: 12px;">
            <li class="nav-item" style="background: none; border: none;">
            <a class="nav-link" [ngClass]="{'active':showCloser=='env'}" style="border: none;" data-toggle="tab" href="#env" (click)="toCloserEnv()">Environmental Data Input</a>		
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showCloser=='sei'}"style="border: none;" data-toggle="tab" href="#sei" (click)="toCloserSeismic()">Seismic Data Input</a>
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showCloser=='zon'}"style="border: none;" data-toggle="tab" href="#zon" (click)="toCloserZoning()">Zoning Data Input</a>
            </li>
            <li class="nav-item" style="background: none; border: none;">
              <a class="nav-link" [ngClass]="{'active':showCloser=='eng'}"style="border: none;" data-toggle="tab" href="#eng" (click)="toCloserEng()">Engineering Data Input</a>
            </li>
          </ul>
          <!-- Tab panes -->
          <div class="tab-content" >
            
            <div id="env" class="container tab-pane" [ngClass]="{'active':showCloser=='env','fade':showCloser!='env' }" style="width:100%; padding:0; height:60vh; overflow:auto">
              
              <ng-container *ngFor="let f of closerEnvdata">
                <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                  <tr>
                    <th colspan="3"  style="background-color: #ccc;color:#202a3c;">{{f['CLOSER_CATEGORY']}}</th>
                  </tr>
                  <ng-container *ngFor="let r of f.CLOSER_QUESTIONS">
                    <tr>
                      <td style="width:40%">{{r.CLOSER_FIELD_NAME}}</td>
                      <td style="width:30%">
                        <span *ngIf="!(r.RF_ASSIGNED!.SLOT_ID>-1)" style="color:#999">{{closerOpt[0]}}</span>
                        <span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                        <a *ngIf="r.CLOSER_FIELD_TYPE!='Selection'" href="javascript:void(0)" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op10.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                        <p-overlayPanel #op10 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                          <ng-template pTemplate>
                            <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                            <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                            <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateCloser(r)">Remove Selection</button>
                            <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                            <ng-container *ngFor="let slot of filtedSlot">                      
                              <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateCloser(r, slot)"><label>{{slot.KEY}}</label>
                              <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op11.toggle($event)"></i><br>
                              <p-overlayPanel #op11 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                                <ng-template pTemplate>
                                  <div style="height:140px; overflow: auto;font-size: 12px;">
                                    <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                      .<label>{{choice}}</label><br>
                                    </ng-container>
                                  </div>   
                                </ng-template>
                              </p-overlayPanel>
                            
                            </ng-container>
                          </div>
                          </ng-template>
                        </p-overlayPanel>
                      </td>                      
                    </tr>
                  </ng-container>
                </table>
              </ng-container>
            
          </div>
          <div id="sei" class="container tab-pane"  [ngClass]="{'active':showCloser=='sei','fade':showCloser!='sei' }" style="width:100%; padding:0; height:60vh; overflow:auto">
            <ng-container *ngFor="let f of closerSeisdata">
              <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                <tr>
                  <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['CLOSER_CATEGORY']}}</th>
                </tr>
                <ng-container *ngFor="let r of f.CLOSER_QUESTIONS">
                  <tr>
                    <td style="width:40%">{{r.CLOSER_FIELD_NAME}}</td>
                    <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{closerOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                      <a  *ngIf="r.CLOSER_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                      <p-overlayPanel #op12 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                        <ng-template pTemplate>
                          <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                          <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                          <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateCloser(r)">Remove Selection</button>
                          <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                          <ng-container *ngFor="let slot of filtedSlot" >
                            <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateCloser(r, slot)"><label>{{slot.KEY}}</label>
                            <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                            <p-overlayPanel #op13 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                              <ng-template pTemplate>
                                <div style="height:140px; overflow: auto;font-size: 12px;">
                                  <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                    .<label>{{choice}}</label><br>
                                  </ng-container>
                                </div>   
                              </ng-template>
                            </p-overlayPanel>
                          
                          </ng-container>
                        </div>
                        </ng-template>
                      </p-overlayPanel>
                    </td>                    
                  </tr>
                </ng-container>
              </table>
            </ng-container>
          </div>
              <div id="zon" class="container tab-pane"  [ngClass]="{'active':showCloser=='zon','fade':showCloser!='zon' }" style="width:100%; padding:0; height:60vh; overflow:auto">
                <ng-container *ngFor="let f of closerZoningdata">
                  <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                    <tr>
                      <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['CLOSER_CATEGORY']}}</th>
                    </tr>
                    <ng-container *ngFor="let r of f.CLOSER_QUESTIONS">
                      <tr>
                        <td style="width:40%">{{r.CLOSER_FIELD_NAME}}</td>
                        <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{closerOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                          <a  *ngIf="r.CLOSER_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                          <p-overlayPanel #op12 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                            <ng-template pTemplate>
                              <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                              <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                              <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateCloser(r)">Remove Selection</button>
                              <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                              <ng-container *ngFor="let slot of filtedSlot" >
                                <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateCloser(r, slot)"><label>{{slot.KEY}}</label>
                                <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                                <p-overlayPanel #op13 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                                  <ng-template pTemplate>
                                    <div style="height:140px; overflow: auto;font-size: 12px;">
                                      <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                        .<label>{{choice}}</label><br>
                                      </ng-container>
                                    </div>   
                                  </ng-template>
                                </p-overlayPanel>
                              
                              </ng-container>
                            </div>
                            </ng-template>
                          </p-overlayPanel>
                        </td>                        
                      </tr>
                    </ng-container>
                  </table>
                </ng-container>
              </div>
                  <div id="eng" class="container tab-pane"  [ngClass]="{'active':showCloser=='eng','fade':showCloser!='eng' }" style="width:100%; padding:0; height:60vh; overflow:auto">
                    <ng-container *ngFor="let f of closerEngdata">
                      <table class="fmeset" style="width:100%; margin-top:20px; background-color: #dedede;">
                        <tr>
                          <th colspan="3" style="background-color: #ccc;color:#202a3c;">{{f['CLOSER_CATEGORY']}}</th>
                        </tr>
                        <ng-container *ngFor="let r of f.CLOSER_QUESTIONS">
                          <tr>
                            <td style="width:40%">{{r.CLOSER_FIELD_NAME}}</td>
                            <td style="width:30%"><span *ngIf="!(r.RF_ASSIGNED.SLOT_ID>-1)" style="color:#999">{{closerOpt[0]}}</span><span *ngIf="r.RF_ASSIGNED.SLOT_ID>-1" style="background-color: yellow;">{{r.RF_ASSIGNED.KEY}}</span>
                              <a  *ngIf="r.CLOSER_FIELD_TYPE!='Selection'" class="float-right" title="Choose Repeat Field" [ngStyle]="{'color':r.RF_ASSIGNED.SLOT_ID>-1?'#C2D63F':'#333'}" (click)="op12.toggle($event); filtedSlot=slots"><i class="far fa-list-alt"></i></a>
                              <p-overlayPanel #op12 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                                <ng-template pTemplate>
                                  <!--<input type="text" style="font-size: 12px;"><i class="fas fa-search"></i>-->
                                  <input type="search" style="font-size: 12px; padding: 2px;" placeholder='Search' (input)="filterSlot($event)">
                                  <button type="button" class="btn btn-sm btn-outline-light pt-0 pb-0 pl-2 pr-2 ml-2" (click)="updateCloser(r)">Remove Selection</button>
                                  <div style="height:40vh; overflow: auto;font-size: 12px; width:300px">                      
                                  <ng-container *ngFor="let slot of filtedSlot" >
                                    <input type="radio" name="RFs" [checked]="slot.SLOT_ID==r.RF_ASSIGNED.SLOT_ID" (change)="updateCloser(r, slot)"><label>{{slot.KEY}}</label>
                                    <i *ngIf="slot.SELECTION_CHOICES.length>0" class="far fa-eye ml-1" style="color:#C2D63F" (click)="op13.toggle($event)"></i><br>
                                    <p-overlayPanel #op13 [appendTo]="closerModal" [showCloseIcon]="true" [dismissable]="true">
                                      <ng-template pTemplate>
                                        <div style="height:140px; overflow: auto;font-size: 12px;">
                                          <ng-container *ngFor="let choice of slot.SELECTION_CHOICES.split(';;')">
                                            .<label>{{choice}}</label><br>
                                          </ng-container>
                                        </div>   
                                      </ng-template>
                                    </p-overlayPanel>
                                  
                                  </ng-container>
                                </div>
                                </ng-template>
                              </p-overlayPanel>
                            </td>                            
                          </tr>
                        </ng-container>
                      </table>
                    </ng-container>
                   </div> 
           <div class="col-md-12 justify-content-center text-center mt-1">
            <button class="btn btn-dark btn-sm pt-2 pb-2 pl-4 pr-4" type="button" data-dismiss="modal">Close</button>
          </div>
    </div>
  </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="deleteResumeModal" tabindex="-1" role="dialog" aria-labelledby="deleteResumeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteResumeModalLabel">Are you sure you want to delete the resume?</h5>
        <button type="button" (click)="dismissConfirm($event);" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <button type="button" class="btn btn-secondary" (click)="dismissConfirm($event);">Go Back</button>
        <button style="float:right" type="button" class="btn btn-primary" (click)="confirmDeleteResume()">Delete</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="signatureStyleSettingsModal" tabindex="-1" role="dialog" aria-labelledby="signatureStyleSettingsModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 800px; width: 90%;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="signatureStyleSettingsModalLabel">Signature Style</h5>
        <button type="button" (click)="dismissConfirm($event);" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <p class="text-muted mb-0">Manage your signature styles. Click the <i class="fas fa-times"></i> icon to delete a style.</p>
              <span class="badge badge-info">{{signStyles.length}} Style{{signStyles.length !== 1 ? '(s)' : ''}}</span>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Style Name</th>
                    <th style="width: 100px; text-align: center;">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let style of signStyles">
                    <td>{{style.SIGNATURE_STYLE_NAME}}</td>
                    <td style="text-align: center;">
                      <button type="button" class="btn btn-sm btn-outline-danger" 
                              (click)="showDeleteSignatureStyleConfirm(style)" 
                              title="Delete Signature Style"
                              *ngIf="!isDefaultStyle(style.SIGNATURE_STYLE_NAME)">
                        <i class="fas fa-times"></i>
                      </button>
                    </td>
                  </tr>
                  <tr *ngIf="signStyles.length === 0">
                    <td colspan="2" class="text-center text-muted" style="padding: 20px;">No signature styles found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteSignatureStyleModal" tabindex="-1" role="dialog" aria-labelledby="deleteSignatureStyleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteSignatureStyleModalLabel">Are you sure you want to delete this signature style?</h5>
        <button type="button" (click)="dismissConfirm($event);" class="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>You are about to delete the signature style: <strong>{{signatureStyleToDelete?.SIGNATURE_STYLE_NAME}}</strong></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="dismissConfirm($event);">Go Back</button>
        <button style="float:right" type="button" class="btn btn-primary" (click)="confirmDeleteSignatureStyle()">Delete</button>
      </div>
    </div>
  </div>
</div>